export const translation_EN = {
  diveEditDashboard: "Dive into the edit dashboard.",
  passwordNotMatch: "Password not match",
  successChangedPassword: "Success ! You changed your password",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmNewPassword: "Confirm new password",
  updatePassword: "Update Password",
  pleaseInformPhoneNumber: "Please, inform your phone number.",
  dataEditedSuccess: "Data edited with success",
  myData: "My Data",
  readingModePleaseContact:
    "Read-Only User. Contact your company's admin user to access editing features",
  youCanOnlyChangeItems: "You can only change items that you created yourself.",
  actions: "Actions",
  showingResults: "Showing {{start}} to {{end}} of {{total}} results",
  previousPage: "Previous page",
  nextPage: "Next page",
  firstPage: "First page",
  lastPage: "Last page",
  page: "Page",
  of: "of",
  navBar: {
    operationInsight: "Operational Events",
    forecastCharts: "Forecast Charts",
    sensorCharts: "Sensor Charts",
    dynamicUkcCharts: "Dynamic UKC Charts",
    alerts: "Alerts",
    mooringLines: "Mooring lines",
    morphologyMap: "Morphology map",
    admin: "Admin",
    myData: "My Data",
    changePassword: "Change Password",
    userManager: "User Manager",
    notificationManager: "Notification Manager",
    forecastChecker: "Forecast checker",
    settings: "Settings",
    errorWhileGetMooringAuthentication:
      "Oops! Error while get mooring authentication! Please contact us.",
    logout: "Logout",
    portuguese: "Portuguese",
    english: "English",
    spanish: "Spanish",
    shareForecast: "Share forecast",
    new: "New",
    shareForecastWithOutLeaving: "Share the forecast without leaving i4cast!",
    reportOccurrence: "Report occurrence",
    occurrences: "Occurrences",
    importOccurrence: "Import occurrence",
    youAreGoingToBeRedirect: "You will be redirected to another page",
    errorWhileGetUKCAuthentication:
      "Oops! Error while get dynamic ukc authentication! Please contact us.",
    manageStation: "Station Manager",
    performance: "Performance",
    eventHistory: "Event history",
    eventAnalysis: "Event Analysis",
    watchTutorial: "Watch Tutorial",
    learnHowToUse: "Learn How to Use i4cast",
    riverForecast: "River Forecasts",
    services: "Services",
    locations: "Locations",
  },
  login: {
    usernameNoLongerValid:
      "Sorry but this username has been deactivated and is no longer valid.",
    passwordNotBeenChanged:
      "The password has not been changed. We ask you to repeat the operation or contact contato@i4sea.com.",
    errorValidatingPassword: "Error in validating your current password.",
    resetPassword: "Reset password",
    logIn: "Log in",
    verificationCodeSent: "Verification code sent!",
    successWeveSentYouEmailPasswordReset:
      "Success! We’ve sent you an email with password reset instructions.",
    doneNewPasswordSaved: "Done! New password saved",
    successGoBackToLogin: "Success! Go back to login and welcome back.",
    login: {
      usernameNoLongerValid:
        "Sorry but this username has been deactivated and is no longer valid.",
      updateI4castData: "Update your data to maximize the use of i4cast",
      resetPassword: "Reset password",
      gotIt: "Got it!",
      skip: "skip",
      emailUsername: "Email or username",
      password: "Password",
      keepLogged: "Keep me logged in",
      userPasswordIncorrect:
        "Sorry, user or password isn’t right. We can help you recover your",
      logInTitle: "Log in",
      logIn: "Log in",
      forgotUsername: "Forgot username?",
      forgotPassword: "Forgot password?",
      alert: "Alert",
      verificationCodeSent: "Verification code sent!",
      successWeveSentYouEmailPasswordReset:
        "Success! We’ve sent you an email with password reset instructions.",
      doneNewPasswordSaved: "Done! New password saved",
      successGoBackToLogin: "Success! Go back to login and welcome back.",
      itAppearsYouAreDisconnected:
        "It appears you are disconnected. Please check your internet connection.",
      sorryWeSeemToHaveEncountered:
        "Sorry, we seem to have encountered a problem with our server. Please try again later.",
      hidePassword: "Hide password",
      showPassword: "Show password",
      eyesClosed: "Eyes closed",
      eyesOpen: "Eyes open",
    },
    forgotPassword: {
      recoverPassword: "Recover password",
      next: "Next",
      cancel: "Cancel",
      thereWasProblem: "There was a problem",
      pleaseInputEmail: "Please input your email!",
      updatePassword: "Update password",
      newPassword: "New password",
      pleaseCheckEmail: "Please check your email box",
      enterCodeVerification: "Enter your verification code",
      pleaseInputVerificationCode: "Please input your verification code",
      pleaseInputYourPassword: "Please input your password",
      pleaseInputYourNewPassword: "Please input your new password",
      pleaseInputYourNewPasswordAgain: "Please input your new password again",
      confirmNewPassword: "Confirm new password",
    },
    changePassword: {
      changePassword: "Change password",
      updatePassword: "Update password",
      cancel: "Cancel",
      dataEditedSuccess: "Data edited with success",
      currentPassword: "Current password",
      pleaseInputCurrentPassword: "Please input your current password",
      newPassword: "New password",
      passwordNotMatch: "Password not match",
      pleaseInputYourNewPassword: "Please input your new password",
      pleaseInputYourNewPasswordAgain: "Please input your new password again",
      confirmNewPassword: "Confirm new password",
      success: "Success",
      error: "Error",
    },
    newPasswordForm: {
      verificationCode: "Verification code",
      newPassword: "New password",
      resetPassword: "Reset password",
      returnToLogin: "Return to login",
      verificationCodePasswordIncorrect:
        "Verification code or password incorrect.",
    },
    recoverPasswordForm: {
      typeYourEmail: "Type your email",
      sendInstructionsByEmail: "Send instructions by email",
      emailIncorrect: "Email incorrect.",
      returnToLogin: "Return to login",
    },
    signIn: {
      alert: "Alert",
      updateI4castData: "Update your data to maximize the use of i4cast",
      gotIt: "Got it!",
      skip: "skip",
      thereWasAProblemWithLogin:
        "There was a problem with the login, check your credentials.",
      user: "User",
      password: "Password",
      logIn: "Log in",
      forgotPassword: "Forgot password?",
    },
  },
  notificationManager: {
    pleaseEnterMessageTitle: "Please enter a message title.",
    pleaseEnterMessageContent: "Please enter a message content.",
    confirm: "Confirm",
    confirmPushNotificationSent:
      "Confirm push notification sent to {{totalUsers}} target users?",
    send: "Send",
    cancel: "Cancel",
    selectCompany: "Select a company",
    next: "Next",
    previous: "Previous",
    sendPushNotification: "Send push notification",
    pushNotificationSentSuccessfully: "Push notification sent successfully",
    submissionFailed: "Submission Failed",
    checkModifingInformationResubmiting:
      "Please check and modify the following information before resubmitting.",
    tryAgain: "Try Again",
    allClearYouDontHaveNewMessages:
      "All clear ! You don’t have any new messages.",
    unreadNotification: "Unread notification",
    markAllAsRead: "Mark all as read.",
    notifications: "Notifications",
    sendNewPushes: "Send new pushes",
  },
  oceanWeatherIntelligence: {
    errorGeneratingInsight:
      "Ops! There is an issue when generating events for this specific location and some of them have become inaccessible. Please, contact us for more information.",
    errorGetChartData: "Error to try get data for chart. Please contact us.",
    environmentalVariablesNotFound:
      "Ooops! Environmental variables not found for this location!",
    insightIsCausedBy: "Event is caused by:",
    end: "End",
    start: "Start",
    summary: "Summary",
    probability: "Probability",
    to: "to",
    rare: "Very Low",
    low: "Low",
    medium: "Medium",
    high: "High",
    almostCertain: "Very High",
    locationInsight: "Location/Event",
    riskExtreme: "Extreme risk",
    riskHigh: "High risk",
    riskModerate: "Moderate risk",
    riskLow: "Low risk",
    probabilityRisk: "Probability",
    severity: "Severity",
    riskMatrix: "Risk Matrix",
    impactedArea: "of impacted area",
    impactedPoints: "of affected points",
    pointsFraction: "{{affected}} of {{total}}",
    affectedPointsSuffix: "affected points",
    pointsWithoutForecast_one: "{{count}} point with no forecast available",
    pointsWithoutForecast_other: "{{count}} points with no forecast available",
    affectedPointsDetail: "Points with occurrence",
    pointIndex: "Point {{index}}",
    point: "Point",
    area: "Area",
    multipoint: "Multiple Points",
    processing: "processing",
    error: "error",
    // workspace#385 (US2): what an area row says when it draws no bars.
    // Sao SEIS estados e cinco rotulos: `ready` desenha barra e nao precisa de
    // texto. notPlanned must NEVER read as "does not occur" -- that is the defect
    // this story exists to close.
    rowState: {
      // O texto historico do marcador, preservado ate a pontuacao: e o que os
      // usuarios leem em todos os idiomas (ver a nota em pt-BR/es).
      doesNotOccur: "No upcoming events!",
      neverWarms: "no model for the variables",
      calculating: "calculating",
      notPlanned: "calculating",
      unavailable: "could not check",
    },
    errorWhileSaveSort:
      "An error occurred while saving the sort order. Please contact us.",
    errorSortListPermission:
      "You do not have permission to sort the list. Please contact the administrator.",
    errorWhileFavoriteDashboard:
      "An error occurred while setting the dashboard as favorite. Please contact us.",
    oceanWeatherIntelligence: {
      clickGoBackPastInsights: "Event History",
      needSelectDashboardPastInsight:
        "Oops! You need to select a dashboard to go back to past forecast",
      diveOperationInsights: "Dive into the Operational Events.",
      editDashboard: "Edit Dashboard",
      selectDashboard: "Select a Dashboard",
      needSelectDashboardAddLocation:
        "Oops! You need to select a dashboard to add a location",
      editLocation: "Edit Location",
      editInsight: "Edit Event",
      currentInsight: "Current Event",
      videoTutorials: "Video tutorials",
      time: "Time:",
      operationInsights: "Operational Events",
      eventManager: "Event manager",
      selectDashboardInsight: "Select a dashboard to view its events",
      dashboards: "Dashboards",
      locations: "Locations",
      insights: "Events",
      weStillDontHaveAnyDashboard:
        "We still don't have any dashboard registered.",
      letsGo: "Let's go?",
      addLocation: "Add Location",
      dashboardNoEventsTitle: "Dashboard still without events...",
      dashboardNoEventsDescription:
        "To view the chart, create the first event for the dashboard",
      addLocationInsightToYourDashboard:
        "To view the Graph add a location. Click on 'Add Location' to begin. 😉",
      almostThereCreateInsightVisualizeChart:
        "Almost there! To create an Event and visualize the chart",
      clickHere: "click here",
      selectService: "Select a service",
      showShifts: "Show on chart",
      serviceShift: "Service shift",
      until: "until",
      createServiceAndVisualize:
        "Register a service and view it next to the Events chart",
      createService: "Register service",
      newService: "New!",
      showServiceChart: "Show service on chart",
      selectAserviceToView:
        "Select a service to view your shifts on the Gantt chart, along with forecast events for better planning.",
      probability: "PROBABILITY",
      total: "Total",
      insightsWithProbability:
        "Here's a tip: when you see [Probability] the chance of the event occurring is available.",
      checkTheRiskLevels:
        "See how the risk colors of the events are represented in the risk matrix.",
      clickToLearnMore: "Click to learn more!",
      probabilitySwitch: "Probability",
      whenYouDisable:
        "Disables the event probabilities on the chart, displaying them in a deterministic way.",
      leaveYourFeedback: "Leave your feedback",
      notUsefulAtAll: "1 - Not useful at all",
      veryUseful: "5 - Very useful",
      thanksForFeedback: "Thank you for your feedback! 🙌",
      close: "Close",
      errorSortingList: "Error when sorting list",
      thereAreInsightsWithErrors:
        "Unable to generate one or more area events. Try adjusting the conditions or repositioning the area on the map. If the problem persists, please contact support.",
    },
    insightAlert: {
      alertRemovalFailed: "Alert removal failed. Contact us",
      selectDashboardFilterLocation:
        "Please select a dashboard to filter location",
      alert: "Alert",
      active: "Active",
      insight: "Event",
      location: "Location",
      dashboard: "Dashboard",
      filterDashboard: "Filter a dashboard",
      filterLocation: "Filter a location",
      createNewAlert: "Create New Alert",
      delete: "Delete",
      selectRecipient: "Select a recipient",
      users: "Users",
      userName: "userName",
      addAlert: "Add Alert",
      editAlert: "Edit Alert",
      add: "Add",
      edit: "Edit",
      cancel: "Cancel",
      alertName: "Alert Name",
      alertTitleColumn: "Alert Title",
      eventColumn: "Event",
      pleaseInputAlertName: "Please input the alert's name!",
      alertNameExceedCharactersLimit: "Alert Name exceed 100 characters limit!",
      status: "Status",
      selectDashboardFromList: "Please select a dashboard from the list!",
      selectLocationFromList: "Please select a location from the list!",
      selectInsightFromList: "Please select an event from the list!",
      upTo: "Time in advance",
      selectTimeBeforeEvent: "Please select a up to time before event!",
      minutes: "minutes",
      hour: "hour",
      hours: "hours",
      day: "day",
      days: "days",
      notificationName: "Notification Name",
      notificationNameExceedCharactersLimit:
        "Notification Name exceed 100 characters limit!",
      description: "Description",
      inputLocationSummary: "Please input the location's summary",
      minimunEventDuration: "Minimum event duration",
      eventTimeRange: "Event time range",
      insightLocationTimezone: "*Event location timezone",
      otherConfigurationOptions: "Other configuration options",
      configurationCommingSoon: "This configuration coming soon",
      eventStart: "Event start",
      eventFinish: "Event finish",
      recipient: "Recipient",
      errorGetUserAlert: "Error to get user for alert. Please contact us.",
      errorGetDashboardAlert:
        "Error to get dashboard for alert. Please contact us.",
      errorGetLocationAlert:
        "Error to get location for alert. Please contact us.",
      errorGetInsightAlert: "Error to get event for alert. Please contact us.",
      errorGetAlertsData: "Error to get alerts data. Please contact us.",
      errorLoadingEnvironmentalVariables:
        "Error loading environmental variables. Check your connection and try again.",
      retryLoadEnvVariables: "Try again",
      errorDeleteAlerts: "Error to delete alerts. Please contact us.",
      errorAddAlert: "Error to add alert. Please contact us.",
      errorUpdateAlert: "Error to update alert. Please contact us.",
      errorConflict:
        "An alert with this template already exists. Please find it in the list below to edit.",
      insightAlerts: "Alerts",
      beforeEventsStart: "Before event start",
      notification: "Notification",
      areYouSureWantDeleteThisAlert:
        "Are you sure you want to delete this alert?",
      allUsers: "All Users",
      yes: "Yes",
      no: "No",
      valueRequired: "Value is required",

      thisIsHasNoWhatsapp: "This user does not have WhatsApp registered",
      createFromTemplate: "Create from a template",
      createFromScratch: "Create from event",
      createCustomAlert: "Create custom alert",
      createdFromScratch: "Created from event",
      linkedToInsight: "Linked to event",
      alertsOver3Days:
        "Forecasts beyond 3 days are less certain, so alerts are more likely to change or even be canceled.",
      alertInfo: "Alert information",
      alertTemplate: "Alert template",
      alertType: "Risk category",
      insightBadge: "Event",
      locationColumn: "Location",
      alertTemplateArea: "Alert area",
      exampleRisk: "E.g. risk of container falling",
      alertConditions: "Alert conditions",
      monitoredArea: "Monitored area",
      locationType: "Location Type",
      point: "Point",
      pointDescription: "Ideal for monitoring events at a specific location.",
      area: "Area",
      areaDescription:
        "Ideal for monitoring events around your location of interest.",
      pointDetails: "Point Details",
      back: "Back",
      region: "Region",
      station: "Station",
      pleaseSelectRegionFromList: "Please select a region from the list",
      pleaseSelectStationFromList: "Please select a station from the list",
      deliveryChannel: "Delivery channel",
      enabledDeliveryChannels: "Enabled delivery channels",
      atLeastOneChannelRequired: "Select at least one delivery channel",
      userToReceiveAlert: "Users who will receive the alert",
      comingSoon: "coming soon",
      new: "New",
      save: "Save changes",
      saving: "Saving...",
      invalidStationRegionFormat: "Invalid station region format",
      createAndCustomizeAlert:
        "Create and customize alerts for yourself and your team, and get notified about important weather events.",
      filter: "Filter",
      port_closure: "Risk of port closure",
      extreme_wind: "Windstorm risk",
      extreme_rain: "Risk of flooding",
      rough_sea: "Risk of rough sea",
      no_category: "No category",
      tree_fall: "Risk of tree fall",
      roof_damage: "Risk of roof damage",
      landslide: "Risk of landslide",
      extreme_heat: "Risk of extreme heat",
      wildfire: "Risk of wildfire",
      fog: "Risk of fog",
      low_visibility: "Risk of low visibility",
      lightning_storm: "Risk of lightning storm",
      clear: "Clear",
      filtrate: "Filter",
      filterList: "Filter list",
      searchByAlert: "Search by alert name",
      searchByUserName: "Search by user name",
      duplicateAlertTemplate:
        "You already have an alert using this template. Please edit the existing alert or choose a different template.",
      clickToLearnMore: "Click to learn more!",
      withReady:
        "With ready-to-use alert templates, you choose an area and monitor",
      portClosureRisk:
        "port closure risks and operational and structural risks",
      moreComingSoon: "(more coming soon)",
      whatIsAndHowItWorks: "What is it, and how does it work?",
      keepYourNumber:
        "Keep your number updated to receive notifications at real pace.",
      gotIt: "Got it",
      theBigDifference:
        "The big difference with this new alert is the monitoring by area of ​​your operation, in addition to sending directly on WhatsApp.",
      alertTitle: "Operational, structural, and environmental safety risk",
      alertPeriod:
        "📅 Between: <strong>Saturday (26) at 3pm</strong> and <strong>11am Sunday (27)</strong>",
      environmentalConditionsTitle: "🌍 Environmental conditions:",
      environmentalConditionWaves: "• Waves between 3.5 and 4.5 m",
      environmentalConditionWinds: "• Winds between 28 and 35 knots",
      expectedImpactsTitle: "Alert description:",
      impactDamage: "• Damage to structures and equipment",
      impactSafety: "• Personnel safety risk",
      impactInterruption: "• Operation interruption",
      alertNote:
        "Initial alert. We are monitoring and will notify you in case of changes or cancellation.",
      newAlertViaWpp: "New alerts via Whatsapp",
      exampleAlert: "Example of alert:",
      weVeRedesigned:
        "We’ve redesigned the alert center, and it now includes regional risk alerts sent via WhatsApp,",
      // Template titles
      extremeHeatTitle: "Extreme heat risk",
      extremeWindTitle: "Windstorm risk",
      extremeRainTitle: "Flood risk",
      landslideTitle: "Landslide risk",
      wildfireTitle: "Wildfire risk",
      treeFallTitle: "Tree fall risk",
      roofDamageTitle: "Roof damage risk",
      roughSeaTitle: "Rough sea risk",
      fogTitle: "Fog risk",
      lowVisibilityTitle: "Low visibility risk",
      lightningStormTitle: "Lightning activity risk",
      noCategoryTitle: "Operational alert",
      portClosureTitle: "Risk of port closure",
      // Template descriptions
      extremeHeatDescription:
        "Very high temperatures may affect teams and operations.",
      extremeWindDescription:
        "Strong winds and intense gusts may cause damage and disruptions.",
      extremeRainDescription:
        "Heavy rainfall increases flood risk and impacts on access routes.",
      landslideDescription: "High rainfall volume increases landslide risk.",
      wildfireDescription: "Dry weather and wind favor fire spread.",
      treeFallDescription:
        "Saturated soil and wind increase falling tree risk.",
      roofDamageDescription: "Intense gusts may cause damage to roofs.",
      roughSeaDescription:
        "High waves and rough seas may compromise maritime operations.",
      fogDescription: "Fog may reduce visibility and affect safety.",
      lowVisibilityDescription: "Reduced visibility may impact operations.",
      lightningStormDescription:
        "Storms with organized electrical discharges increase risk to people, equipment, and outdoor operations.",
      noCategoryDescription:
        "Non-standard environmental conditions have been identified. Assess potential impacts on operations.",
      // Legacy descriptions (kept for backwards compatibility)
      possibilityOfImpacts:
        "Potential impacts on assets and operations, with priority on team safety.",
      potentialSuspension:
        "Potential suspension of maneuvers, logistical delays, and the need to replan terminal operations.",
      possibilityOfFlooding:
        "Possibility of flooding with impacts on assets and operational continuity.",
      customMessage: "Custom message",
      alertTitleDescribe: "Alert title",
      alertTitlePlaceholder: "Title that will be displayed in the alert",
      titleThatWillBe:
        "Title that will be displayed at the beginning of the alert message. Be clear and objective.",
      alertDescription: "Alert description",
      alertDescriptionPlaceholder: "Alert description",
      describeTheImpact:
        "Describe the impact or actions to be taken by the team.",
      viewMessage: "View message",
      customizeMessage: "Customize message",
      sendConfig: {
        title: "Send settings",
        advanceTime: "Lead time",
        selectPlaceholder: "Select",
        receipt: "Also receive",
        dayPeriodOfInterest: "Day period of interest",
        eventCanBeCapturedAnytime:
          "The event can be captured at any time of day",
        timezoneHelperText: "Timezone of the event location",
        eventCanBeCapturedBetween: "The event can be captured between",
        minimumEventDuration: "Minimum event duration",
        minMaxAdvanceTime: "Minimum/Maximum lead time",
        advanceTimeSubtitle:
          "The captured alert will only be sent if within the minimum and maximum advance time window.",
        alertsOver3DaysWarning:
          "Alerts over 3 days have a higher chance of change or cancellation.",
        minMaxValidationError: "Minimum time must be less than maximum time",
        minGapValidationError: "Minimum 1 hour gap between values",
        selectedInterval: "Selected interval",
        receiptOptions: {
          sendUpdates: "Frequent event updates",
          sendCancellations: "Event cancellations",
        },
      },
      alertIcon: "🚨 Alert:",
      selectedUsers: "Selected users",
      channelMismatchWarning: "Warning: Unverified Channels",
      someUsersDoNotHaveVerifiedChannels:
        "Some selected users do not have all delivery channels verified.",
      selectedChannelsNotVerified: "Selected channels without verification",
      usersWithoutChannelWillNotReceiveNotifications:
        "Users without the verified channel will not receive notifications through that channel.",
      goBack: "Go Back",
      saveAnyway: "Save Anyway",
      inLocation: "in",
      thisFieldRequired: "This field is required",
      continue: "Continue",
      drawArea: "Draw an area",
      importGeojson: "Import GeoJSON",
      selectSavedArea: "Select saved area",
      selectAreaAboveToVisualize: "Select the area above to visualize.",
      selectAlertType: "Select the type of alert:",
      editYourArea:
        "Drag the blue points to edit the polygon. Click 'Confirm' when you're done.",
      drawYourArea:
        "Draw the boundaries of your area point by point, each click sets one of the boundaries.",
      confirmArea: "Confirm",
      clearArea: "Clear",
      invalidArea:
        "Make sure the polygon is placed near your registered stations.",
      invalidPoint: "Select a point near your registered stations.",
      backToPrevious: "Back",
      selectStationOnMap: "Select a station on the map.",
      selectPointOrStationOnMap:
        "Select an existing point here or on the map, or click directly to create a new one.",
      searchStationOrCoordinates: "Search station or lat,lon",
      searchAcceptsCoordinates: "Search accepts lat/lon coordinates.",
      noResultsFound: "No results found",
      customPoint: "Selected Point",
      saveStation: "Save station",
      stationSaved: "Saved",
      stationName: "Station name",
      stationNamePlaceholder: "Enter a name for the station",
      coordinates: "Coordinates",
      stationSavedSuccess: "Station saved successfully!",
      errorSavingStation: "Error saving station",
      confirmPoint: "Confirm",
      clearSelection: "Clear selection",
      selectPointOnMap: "Select on map",
      selectedStation: "Selected station",
      changeStation: "Change",
      type: "Type",
      group: "Group",
      addNewGroup: "New group",
      addNewCondition: "New condition",
      isGreaterThan: "is greater than",
      isEqualToOrGreaterThan: "is equal to or greater than",
      isEqualTo: "is equal to",
      isLessThan: "is less than",
      isEqualToOrLessThan: "is equal to or less than",
      and: "AND",
      or: "OR",
      removeGroup: "Remove group",
      noMacroRegionOriginWasFound: "No macro region origin was found.",
      pleaseSelectPointOrArea: "* Please select a point or area.",
      pleaseDrawAnArea:
        "* Please draw an area on the map or import an existing one.",
      selectAreaPlaceholder: "Select an area...",
      successAlertCreated: "Alert created successfully!",
      errorCreatingAlert: "Error creating alert",
      andVerifyConditionTrueOrVerifyAtLeastConditionTrue:
        "AND: Checks if all conditions are true. OR: Checks if at least one of the conditions is true.",
      step1DataAndLocation: "Step 1 - Data and location",
      step1Location: "Step 1 - Location",
      step1DataAndInsight: "Step 1 - Data and Event",
      step2Conditions: "Step 2 - Conditions",
      step2Preferences: "Step 2 - Delivery preferences",
      step3Preferences: "Step 3 - Delivery preferences",
      createAlert: "Create alert",
      createEvent: "Create event",
      dropTheFile: "Drop the file here...",
      dragAndDrop: "Drag and drop a GeoJSON file here, or click to browse.",
      saveArea: "Save area",
      areaSaved: "Area saved",
      areaName: "Area Name",
      areaNamePlaceholder: "Enter the area name",
      requiredField: "This field is required",
      areaSuccessOnSave: "Success! Your area has been saved",
      errorCreatingArea: "Error creating area",
      areaNameAlreadyExists:
        "An area with this name already exists. Please choose a different name.",
      locationDataWarningTitle: "Attention to the entered information",
      locationDataWarningDescription:
        "Upon confirmation, the location data entered so far will be lost. Do you want to continue?",
      yesWantToContinue: "Yes, I want to continue",
      alertTypeChangeWarningTitle: "Attention to the change in alert type",
      alertTypeChangeWarningDescription:
        "By changing the alert type, the conditions will be replaced with the default conditions of the new type. Do you want to continue?",
      alertTypeChangeChoiceDescription:
        "When changing the alert type, the conditions also change. How would you like to continue?",
      alertTypeChangeDescription:
        "When changing the alert type, the conditions also change. How would you like to continue?",
      keepCurrentConditions: "Keep my conditions",
      useTemplateConditions: "Use default conditions",
      useTypeDefault: "Use default conditions",
      keepMyChanges: "Keep my conditions",
      // Alert category tabs
      standaloneAlert: "My own alert",
      insightAlert: "Link to an event",
      selectAnInsight: "Select an event",
      selectDashboard: "Dashboard",
      selectDashboardPlaceholder: "Select a dashboard...",
      selectInsight: "Event",
      selectInsightPlaceholder: "Select an event...",
      searchInsightPlaceholder: "Search event...",
      noInsightsFound: "No events found",
      noInsightsInLocation: "No events in this location",
      selectedInsightConditions: "Selected event conditions",
      eventAction: "Event action",
      eventActionTooltip:
        "Defines how weather conditions affect your operation. In Restrictive mode, the conditions limit or prevent the operation. In Permissive mode, the conditions are required for the operation to take place.",
      restrictive: "Restrictive",
      permissive: "Permissive",
      conditionsPreview: "Conditions Preview",
      conditionPlaceholder: "Condition will be displayed here",
      example: "Example",
      selectInsightToSeeConditions: "Select an event to see its conditions",
      noConditionsAvailable: "No conditions available",
      insightAlertTitlePrefix: "Event",
      monitoredLocation: "Monitored Location",
      monitoredAreaPolygon: "Monitored area (polygon)",
      confirm: "Confirm",
      condition: {
        and: "AND",
        or: "OR",
      },
    },
    sensorAlert: {
      sectionTitle: "Measured sensor alerts",
      howItWorks: "How it works",
      newBadge: "New",
      // Spec 043 — Lightning support
      sensorTypeRainTab: "Rain",
      sensorTypeLightningTab: "Lightning",
      lightningPointPlaced: "Lightning point placed",
      lightningSelectionInfo:
        "The lightning variable works by selecting a point to monitor.",
      lightningSelectionCallToAction:
        "Click on the map to define the monitoring point for this alert.",
      lightningRadiusLabel: "Monitoring radius",
      lightningRadiusDescription:
        "We'll use the selected point as reference",
      lightningRadiusValue: "{{km}} km",
      clearLightningSelection: "Clear selection",
      lightningSilenceWindowLabel: "Silence window",
      lightningSilenceWindowHint:
        "We will consider the event closed after this time has passed since the last strike.",
      lightningSilenceWindowOption: "{{min}} min",
      increase: "Increase",
      decrease: "Decrease",
      removeRainAlert: "Remove rain alert",
      removeLightningAlert: "Remove lightning alert",
      removeRainAlertConfirmTitle: "Remove rain alert?",
      removeRainAlertConfirmDescription:
        "You'll lose the sensor selection and any configured rain conditions.",
      removeLightningAlertConfirmTitle: "Remove lightning alert?",
      removeLightningAlertConfirmDescription:
        "You'll lose the monitoring point and the lightning configuration.",
      removeAlertConfirmButton: "Remove",
      noNearbySensorsButLightningAvailable:
        "No sensors near your location, but you can still configure a lightning alert.",
      tipoColumn: "Type",
      chuvaLabel: "Rain",
      raioLabel: "Lightning",
      LIGHTNING_RADIUS_OUT_OF_RANGE:
        "Monitoring radius must be between 1 and 100 km.",
      LIGHTNING_ALL_CLEAR_INVALID:
        "Invalid silence window. Accepted values: 1, 5, 10, 30, or 60 min.",
      LIGHTNING_NOTIFICATION_INVALID:
        "Invalid alert frequency.",
      LIGHTNING_POINT_INVALID:
        "Invalid lightning point coordinates.",
      LIGHTNING_ANCHOR_INVALID:
        "Invalid station anchor on lightning alert.",
      howItWorksExampleTitle: "Message example:",
      howItWorksExampleLine1: "Rain Sensor Alert",
      howItWorksExampleLine2Bold: "Highest accumulation (24h): 35.3 mm",
      howItWorksExampleLine2Rest: " at sensor <sensor name>",
      howItWorksExampleLine3Label: "Sensor readings:",
      howItWorksExampleLine3Item1:
        " • 2 of 4 active sensors recorded rainfall accumulation > 20 mm (24h)",
      howItWorksExampleLine3Item2: " • 1 sensor offline",
      howItWorksExampleLine4: "Alert configured for event:",
      howItWorksExampleLine5: "Flooding at tram track in <location>",
      howItWorksTooltip:
        "Measured sensor alerts notify you when real-time data from physical sensors exceed the conditions you configure. Unlike forecast alerts, these are triggered by actual measured values.",
      sensorsAvailable: "{{count}} sensors available",
      sensorsAvailable_one: "{{count}} sensor available",
      suggestionText: "{{count}} sensors - 30km radius",
      suggestionText_one: "{{count}} sensor - 30km radius",
      suggestionFoundDescription:
        "Found <b>{{count}}</b> sensors near your location.",
      suggestionFoundDescription_one:
        "Found <b>{{count}}</b> sensor near your location.",
      suggestionCardSubtitle: "{{count}} within {{radius}}km radius",
      suggestionCardSubtitle_one: "{{count}} within {{radius}}km radius",
      viewNearbySensors: "View nearby sensors",
      createMyOwnWay: "Create my own way",
      disableAlert: "Disable alert",
      viewMessage: "View message",
      selectedSensors: "{{count}} sensors selected",
      selectedSensors_one: "{{count}} sensor selected",
      emptyStateTitle: "No sensors near the selected location",
      emptyStateDescription:
        "There are no precipitation sensors available in this region.",
      errorLoadingSensors: "Error loading sensors. Please try again.",
      errorLoadingSensorEnvironmentalVariables:
        "Error loading environmental variables. Please try again.",
      retry: "Try again",
      disableAlertModalTitle: "Disable sensor alert",
      disableAlertModalDescription:
        "Are you sure you want to disable the sensor alert? The selected sensors and conditions will be removed.",
      disableAlertConfirm: "Disable",
      disableAlertCancel: "Cancel",
      closeAriaLabel: "Close",
      step3DisableModalTitle: "Condition change notice",
      step3DisableModalDescription:
        "Currently sensor data is only enabled on the event with alert. By disabling the alert, you will stop receiving these updates. Do you want to continue?",
      step3DisableConfirm: "Disable sensor data",
      step3DisableCancel: "Back",
      sensorConditionsEmptyStateTitle:
        "Add a condition to trigger the sensor alert",
      sensorConditionsEmptyStateCreateButton: "Create condition",
      singleSensorWarning:
        "For better monitoring in the area of your alert, we recommend selecting more than 1 sensor.",
      sensorSelectionTitle: "Select precipitation sensors",
      sensorSelectionDescription:
        "Click on the sensors to select or deselect them.",
      sensorSuggestionReviewDescription:
        "These sensors were suggested based on the 30km radius. You can adjust the selection.",
      sensorSelectionTitleMulti: "Sensor selection",
      sensorSelectionSubtitleMulti:
        "Sensors for each variable you want to use for the event:",
      concludeConfiguration: "Finish configuration",
      confirmSelection: "Confirm",
      backToEvent: "Back",
      noSuggestionFound: "No sensors were found near the selected location,",
      createAlertOutsideLocation:
        "would you like to create an alert with a sensor outside the location?",
      createAlert: "Create alert",
      includeTitle: "Include measured data alert?",
      viewSelectedSensorsTooltip: "Selected sensors:",
      editSensors: "Edit sensor selection",
      editSelection: "Edit selection",
      howItWorksModalTitle: "Additional sensor alert",
      howItWorksBody1:
        "When configuring an event, you can go beyond forecast conditions and also include an alert based on real-time sensor data.",
      howItWorksBody2Normal: "By activating this option, you will receive",
      howItWorksBody2Bold:
        "separate alerts — one for forecast and one for sensor.",
      periodicityLabel: "Alert periodicity",
      periodicityRecurring: "Recurring",
      periodicitySingle: "Single",
      frequencyLabel: "Receive updates every",
      frequencyHour_one: "{{count}} hour",
      frequencyHour: "{{count}} hours",
      recurringDescription:
        "Receive periodic sensor updates at the defined interval, regardless of changes",
      singleDescription:
        "Receive an alert when the value exceeds the limit and another when it returns to normal.",
      recurringTooltipTitle: "Recurring Send",
      recurringTooltip:
        "Receive periodic sensor updates at the defined interval, regardless of changes",
      singleTooltipTitle: "Single Send",
      singleTooltip:
        "Receive an alert when the value exceeds the limit and another when it returns to normal.",
      templateModalTitle: "View message",
      templateExampleLabel: "Message example",
      templateAlertTitle: "Rain Sensor Alert",
      templateMainReading:
        "Highest accumulation (24h): 35.3 mm at sensor {{sensorName}}",
      templateSensorReadingsTitle: "Sensor readings:",
      templateSensorReadingsBullet:
        "{{activeSensors}} of {{totalSensors}} active sensors recorded {{condition}}",
      templateSensorReadingsExample:
        "Active sensors recorded accumulated rainfall > 20 mm (24h)",
      templateInoperantSensors: "Inoperative sensors: 1",
      templateEventLabel: "Alert configured for event:",
      templateLocationPreposition: "in",
      templateExampleSensorName: "Example Sensor",
      templateExampleEventName: "Event name",
      templateExampleLocation: "Location",
      gotIt: "Got it",
      pleaseAddSensorCondition:
        "Please add at least one condition for the sensor alert.",
    },
    operationRule: {
      createDashboard: "Create a new Dashboard",
      informNameForAdd: "Inform the name to add new dashboard.",
      informNameForEdit: "Inform the name for edit.",
      removalFailedContactUs: "Removal failed. Contact us",
      diveIntoEditDashboard: "Dive into the edit dashboard.",
      operationInsight: "Operational Events",
      dashboard: "Dashboard",
      name: "Name",
      pleaseInformNameOfDashboard: "Please inform the name of dashboard.",
      informDashboardName: "Inform dashboard name",
      add: "Add",
      newNameDashboard: "New name Dashboard",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      areYouSureWantDeleteDashaboard:
        "Are you sure you want to delete this dashboard?",
      delete: "Delete",
      videoTutorials: "Video tutorials",
      errorToGetData: "Error to get data. Please contact us.",
      errorToAddData: "Error to add data. Please contact us.",
      needToInformIdForUpdateData: "Need to inform ID for update data",
      errorToUpdateData: "Error to update data. Please contact us.",
      needInformIdForDeleteData: "Need to inform ID for delete data",
      errorToDeleteData: "Error to delete data. Please contact us.",
      yes: "Yes",
      no: "No",
      startCreatingFirstInsight:
        "Start creating your first Event by adding a dashboard",
      editDashboard: "Edit Dashboard",
      deleteDashboard: "Delete Dashboard",
      areYouSureCantUndoThis:
        "Are you sure? {{dashboardName}} will be deleted!",
      newDashboard: "New Dashboard",
      search: "Search",
      dashboardSuccessOnSave: "Success! Your dashboard has been saved",
    },
    operationRuleLocation: {
      youNeedSelectDashboardToAddLocation:
        "Oops! You need to select a dashboard to add a location",
      locationRemovalFailedContactUs: "Location removal failed. Contact us",
      editLocation: "Edit Location",
      operationInsight: "Operational Events",
      location: "Location",
      diveEditDashboard: "diveEditDashboard",
      selectDashboard: "Select a Dashboard",
      addNewLocation: "Add New Location",
      edit: "Edit",
      areYouSureWantDeleteLocation:
        "Are you sure you want to delete this location?",
      yes: "Yes",
      no: "No",
      delete: "Delete",
      videoTutorials: "Video tutorials",
      add: "Add",
      cancel: "Cancel",
      youNeed4AlphaNumericToTheKey:
        "Oops! You need to use 4 alphanumeric characters to the key. ex: ABCD, ABC1, A1BC",
      name: "Name",
      pleaseInputLocationName: "Please input the location's name!",
      key: "Key",
      pleaseInputInitialNameLocation:
        "Please input the initial name for location!",
      inputLocationSummary: "Please input the location's summary",
      region: "Region",
      pleaseSelectRegionFromList: "Select a region",
      station: "Station",
      pleaseSelectStationFromList: "Select a station",
      errorGetLocationData: "Error to get location data. Please contact us.",
      errorAddLocationData: "Error to add location data. Please contact us.",
      errorUpdateLocationData:
        "Error to update location data. Please contact us.",
      errorDeleteLocationData: "Error to delete data. Please contact us.",
      summary: "Summary",
      addNewLocationToYourDashboard: "Add a new location to your dashboard.",
      deleteLocation: "Delete Location",
      areYouSureCantUndoThis: "Are you sure? {{locationName}} will be deleted!",
      save: "Save",
      youNeedToFillAllTheFields: "You need to fill in all fields",
      locationSuccessOnSave: "Success! Your location has been saved",
      stationNotFoundPleaseSelectValidStation:
        "Station not found. Please select a valid station",
      point: "Point",
      pointDescription: "Ideal for monitoring events at a specific location.",
      area: "Area",
      areaDescription:
        "Ideal for monitoring events around your location of interest.",
      locationType: "Location Type",
      monitoredLocation: "Monitored Location",
      pointDetails: "Point Details",
      back: "Back",
      monitoredArea: "Monitored area",
      drawArea: "Draw an area",
      selectSavedArea: "Select saved area",
      importGeojson: "Import GeoJSON",
      pleaseDrawAnArea:
        "* Please draw an area on the map or import an existing one.",
      selectAreaPlaceholder: "Select an area...",
      thisFieldRequired: "This field is required",
      selectAreaAboveToVisualize: "Select the area above to visualize.",
      dragAndDrop: "Drag and drop a GeoJSON file here, or click to browse.",
      dropTheFile: "Drop the file here...",
      saveArea: "Save area",
      areaSaved: "Area saved",
      clear: "Clear",
      invalidArea:
        "Make sure the polygon is placed near your registered stations.",
      confirmLocationTypeChange: "Area event editing",
      areaEventEditing: "Area event editing",
      changePointToAreaWarning:
        "By confirming, this event will take a few minutes to be redisplayed in the Operational Events, do you want to continue?",
      yesIWantToContinue: "Yes, I want to continue",
    },
    operationRuleLocationInsight: {
      youNeedSelectLocationToEditInsight:
        "Oops! You need to select a location to edit an event",
      locationRemovalFailedContactUs: "Location removal failed. Contact us",
      youNeedSelectLocationToAddInsight:
        "Oops! You need to select a location to add a new event",
      editInsight: "Edit Event",
      operationInsight: "Operational Events",
      insight: "Event",
      diveEditDashboard: "Dive into the edit dashboard.",
      selectLocation: "Select a location",
      addNewInsight: "Add New Event",
      edit: "Edit",
      areYouSureWantDeleteInsight:
        "Are you sure you want to delete this event?",
      delete: "Delete",
      videoTutorials: "Video tutorials",
      informGroupConditionInsight:
        "Oops! Inform a group of condition of this event.",
      informConditionGroupsInsight:
        "Oops! Inform a condition in the groups of this event.",
      errorCriticalUpdateGroupConditions:
        "Error critical on update group conditions. Please, contact us!",
      add: "Add",
      name: "Name",
      restrictionType: "Restrictive",
      noRestrictionType: "Permissive",
      insightType: "Event Type",
      tooltipRestrictionType:
        "Choose the event type based on the event conditions: restrictive or permissive.",
      pleaseInputInsightName: "Please input the event's name!",
      stopNavigationForSmallBoats: "Stop navigation for small boats",
      high: "High",
      medium: "Medium",
      low: "Low",
      pleaseEnterSummary: "Please enter a summary",
      theNavigationShouldStoppedWindsTooStrong:
        "The navigation should be stopped because winds are too strong",
      conditions: "Conditions",
      conditionsInsideConditionGroupShouldHaveSameLogicalOperator:
        "Conditions inside condition group should have same logical operator. If you want different logical operators, please add another group",
      pleaseSelectEnvironmentalVariable:
        "Please select a environmental variable",
      isGreaterThan: "is greater than",
      isEqualToOrGreaterThan: "is equal to or greater than",
      isEqualTo: "is equal to",
      isLessThan: "is less than",
      isEqualToOrLessThan: "is equal to or less than",
      pleaseEnterValue: "Please enter the value!",
      addNewCondition: "New condition",
      removeGroup: "Remove group",
      addNewGroup: "New group",
      errorWhileGetDataForInsights:
        "Error while try get data for events. Please contact us.",
      errorWhileAddInsight: "Error while try add event. Please contact us.",
      internalErrorToUpdateData:
        "Internal error to update data. Please contact us.",
      errorDeleteInsight: "Error to delete the event. Please contact us.",
      yes: "Yes",
      no: "No",
      cancel: "Cancel",
      error: "Error",
      insightsProcessing:
        "Area events need time to be processed. Once completed, you will be notified here and via email.",
      details: "Details",
      priority: "Priority",
      summary: "Summary",
      location: "Location",
      and: "AND",
      or: "OR",
      weReAlmostTheNowRegisterInsight:
        "We're almost there! Now you just need to register your first event",
      areYouSureCantUndoThis: "Are you sure? {{insightName}} will be deleted!",
      save: "Save",
      deleteInsight: "Delete Event",
      group: "Group",
      type: "Type",
      youNeedToFillAllTheFields: "You need to fill in all required fields",
      addNewConditionGroupInsight:
        "Add a new group of weather conditions to create your event",
      andVerifyConditionTrueOrVerifyAtLeastConditionTrue:
        "AND: Checks if all conditions are true. OR: Checks if at least one of the conditions is true.",
      groupsAreConditionsAddOneConditions:
        "Groups are sets of weather conditions. Add at least one weather condition for each created group",
      nameRequired: "Name is required",
      summaryRequired: "Summary is required",
      valueRequired: "Value is required",
      insightSuccessOnSave: "Success! Your Event has been saved",
      deleteGroup: "Delete group",
      areYouSureWantDeleteGroup: "Are you sure you want to delete this group?",
      windAndGustProbabilities:
        "Wind and gust probabilities will be available after the next forecast update.",
      continue: "Continue",
      back: "Back",
      gotIt: "Got it",

      operationImpactSeverity: "Severity of the impact on your operation",
      whatIsAndHowItWorks: "What is it, and how does it work?",
      example: "Example",
      containerDropRiskInsight:
        "A risk can be classified as high even if rare, such as in the case of a container falling, where the severity is extreme due to its potential to compromise the safety of those involved in the operation.",
      informSeverityBasedOnImpact:
        "Report the severity based on the impact this event has on your operation.",
      selectSeverity: "Select the severity",
      noImpact: "No impact",
      minor: "Minor",
      moderate: "Moderate",
      major: "Major",
      severe: "Severe",
      insightSeverity: "Risk visualization in events",
      riskMatrixDescription:
        "The risk matrix crosses the probability of an event with the severity of the impact it can cause. i4cast highlights the most important risks in color, helping you act with focus.",
      severityRequired: "Severity is required",
      color: "Color",
      colorOnDashboard: "Color on dashboard",
      blue: "Blue",
      orange: "Orange",
      yellow: "Yellow",
      red: "Red",
      registeredAlerts: "Registered alerts",
      oneAlert: "1 alert",
      multipleAlerts: "alerts",
    },
    insightManager: {
      insightManager: "Event Manager",
      dashboards: "Dashboards",
      locations: "Locations",
      insights: "Events",
      events: "Events",
      eventManager: {
        selectDashboard: "Select Dashboard",
        selectedDashboard: "Selected dashboard",
        createDashboard: "Create new dashboard",
        noLocations: "No events registered for this dashboard",
        noEvents: "No events registered for this location",
        processing: "Processing",
        errorLoadingLocations: "Error loading locations",
        errorLoadingEvents: "Error loading events",
        errorLoadingData: "Error loading locations and events",
        eventReorderSuccess: "Event order updated successfully",
        eventReorderError: "Error saving event order",
        loadingEvents: "Loading events...",
        eventsProcessingAlert: "Some events are being processed",
        newEvent: "New event",
        editEvent: "Edit event",
        deleteEvent: "Delete event",
        editLocation: "Edit location",
        deleteLocation: "Delete location",
        saveOrder: "Save order",
        cancelReorder: "Cancel",
        options: "Options",
        reorderEvents: "Reorder events",
        reorderLocations: "Reorder locations",
        locationReorderSuccess: "Location order updated successfully",
        locationReorderError: "Error saving location order",
        deleteLocationTitle: "Delete location from dashboard",
        deleteLocationDescription:
          "When deleting a location with events, the events are also deleted in the process. Do you want to proceed?",
        deleteEventTitle: "Delete event",
        deleteEventDescription:
          "Do you really want to delete this event? This action cannot be undone.",
        goBack: "Go back",
        deleteAnyway: "Delete anyway",
        deleteLocationSuccess: "Location deleted successfully",
        deleteLocationError: "Error deleting location",
        deleteEventSuccess: "Event deleted successfully",
        deleteEventError: "Error deleting event",
        editLocationSuccess: "Location updated successfully",
        editLocationError: "Error updating location",
        // Dashboard actions
        editDashboard: "Edit dashboard",
        deleteDashboard: "Delete dashboard",
        favoriteDashboard: "Favorite dashboard",
        unfavoriteDashboard: "Unfavorite dashboard",
        editDashboardTitle: "Edit dashboard",
        deleteDashboardTitle: "Delete dashboard",
        deleteDashboardDescription:
          'When deleting the dashboard "{{dashboardName}}", all associated locations and events will be removed. Do you want to continue?',
        dashboardName: "Dashboard name",
        dashboardNamePlaceholder: "Enter the dashboard name",
        save: "Save",
        dashboardUpdateSuccess: "Dashboard updated successfully",
        dashboardUpdateError: "Error updating dashboard",
        dashboardDeleteSuccess: "Dashboard deleted successfully",
        dashboardDeleteError: "Error deleting dashboard",
        dashboardFavoriteSuccess: "Dashboard favorited successfully",
        dashboardUnfavoriteSuccess: "Dashboard unfavorited successfully",
        dashboardFavoriteError: "Error favoriting dashboard",
        dashboardCreatedSuccess: "Dashboard created successfully",
        errorCreatingDashboard: "Error creating dashboard",
        create: "Create",
        cancel: "Cancel",
        requiredField: "Required field",
      },
    },
  },
  registerUser: {
    errorWhileLoadUserAreaOptions: "Error while load user area options",
    youHaveSuccessfullyRegistered:
      "Horaaaay! You have successfully registered and are now able to login!",
    errorWhileRegisterUser: "Error while register user",
    expiredInvitation: "Expired invitation",
    sorryThePageYouVisitedNotExist:
      "Sorry, the page you visited does not exist.",
    youInvitedJoinI4cast: "You've been invited to join i4cast®!",
    invitedBy: "Invited by",
    name: "Name",
    pleaseInputYourName: "Please input your name",
    nameMustContainOnlyLetters: "Name must contain only letters",
    lastName: "Last name",
    pleaseInputYourLastName: "Please input your last name",
    lastNameMustContainOnlyLetters: "Last name must contain only letters",
    username: "Username",
    pleaseInputYourUsername: "Please input your username!",
    lastNameMustStartWithLetter:
      "Must start with a letter, contain only alphanumeric characters, '_' and '.'",
    usernameAlreadyHasAccount: "Username already has an i4cast account",
    password: "Password",
    pleaseInputPassword: "Please input your password!",
    passwordMustContain: "Must contain at least 6 digits and one letter",
    phone: "Phone",
    jobArea: "Job area",
    jobPosition: "Job position",
    register: "Register",
    errorInInvitation: "Error in invitation",
  },
  settings: {
    unitMeasurement: "Unit of measurement",
    success: "Success !",
    yourChangesHaveSaved: "Your changes have been saved.",
    changingUnitStillNotAppliedOperationInsights:
      " Changing the units is still not being applied to the Operation Events!",
    wind: "WIND",
    knots: "knots",
    ms: "m/s",
    mph: "mph",
    kmh: "km/h",
    current: "CURRENT",
    wave: "WAVE",
    m: "m",
    km: "km",
    ft: "ft",
    waterLevel: "WATER LEVEL",
    cm: "cm",
    precipitation: "PRECIPITATION",
    mm: "mm",
    inches: "inches",
    settings: "Settings",
    selectHowYouWantToSee: "Select how you want to view",
    visibility: "Visibility",
    adjustYouPreferences:
      "Adjust your preferences in i4cast—any changes you make will take effect immediately.",
    timezone: "Timezone",
  },
  admin: {
    changePassword: {
      passwordNotMatch: "Password not match",
      successChangedPassword: "Success ! You changed your password",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmNewPassword: "Confirm new password",
      updatePassword: "Update Password",
    },
    myData: {
      pleaseInformPhoneNumber: "Please, inform your phone number.",
      dataEditedSuccess: "Data edited with success",
      myData: "My Data",
      name: "Name",
      pleaseInputYourName: "Please input your name!",
      middleName: "Middle Name",
      lastName: "Last Name",
      pleaseInputYourLastName: "Please input your last name!",
      changePassword: "Change Password",
      email: "Email",
      pleaseInputYourEmail: "Please input your e-mail!",
      selectYourJobPosition: "Select your job position",
      pleaseSelectJobPosition: "Please select your job position from the list!",
      selectYourJobArea: "Select your job area",
      pleaseSelectJobArea: "Please select your job area from the list!",
      edit: "Edit",
      portuguese: "Portuguese",
      english: "english",
      errorGetUserData: "Error to get user data. Please contact us.",
      errorUpdateUserData: "Error to update user data. Please contact us.",
      errorGetUserPositionData:
        "Error to get user position data. Please contact us.",
      errorGetUserAreaData: "Error to get user area data. Please contact us.",
      success: "Success",
      errorUpdateUserLanguage:
        "Error to update user language. Please contact us.",
      error: "Error",
      phone: "Phone",
      pleaseEnterValidPhone: "Please enter a valid phone number",
      updatePhoneNumber: "Update phone number",
      enterYourNewPhone: "Enter your new phone number",
      sendVerificationCode: "Send verification code",
      updateNumber: "Update number",
      verifiedNumber: "Verified number",
      numberNotVerified: "Number not verified",
      phoneSuccessfullyUpdated: "Success! Your phone number have been saved.",
      iAgreeReceive:
        "I agree to receive alerts via WhatsApp about risky conditions.",
      phoneAlreadyInUse: "This phone number is already in use.",
      alreadyVerifiedNumber: "Already verified number",
      verifyPhoneToReceiveAlerts:
        "You created an alert! To receive WhatsApp notifications, you need to verify your phone number.",
    },
    userManager: {
      yourInviteSuccessfullySent:
        "Hooraaay! Your invite was successfully sent and a new user is coming soon!",
      errorWhileSendInvitation:
        "Error while try send invitation. Please contact us.",
      userPermissionGroupSuccessfully:
        "User permission group successfully applied",
      errorWhileEditUser: "Error while try edit user. Please contact us.",
      userDataNotFoundOnList: "User data not found on list. Please contact us.",
      userDeactivatedSuccessfully: "User deactivated successfully",
      userReactivatedSuccessfully: "User reactivated successfully",
      errorWhileDeactivateUser:
        "Error while try deactivate user. Please contact us.",
      errorWhileReactivateUser:
        "Error while try reactivate user. Please contact us.",
      userManager: "User Manager",
      inviteUser: "Invite user",
      inviteNewUserFromOrganization:
        "Invite a new user from your organization to join i4cast®!",
      invite: "Invite",
      thisIsStillNotValidEmail: "This is still not a valid email!",
      pleaseInputYourEmail: "Please input your email!",
      emailAlreadyHasi4cast: "Email already has an i4cast account",
      userGroup: "User group",
      admin: "Admin",
      hasPermissionManageInviteUsers:
        "Has permission to manage and invite new users.",
      basic: "Basic",
      canAccessEditAllFeatures: "Can access and edit all i4cast features.",
      pleaseInput: "Please Input",
      granted: "Granted",
      denied: "Denied",
      name: "Name",
      username: "Username",
      email: "Email",
      permissionGroup: "Permission Group",
      accessToI4cast: "Access to i4cast®",
      areYouSureWantDeactivateUser:
        "Are you sure you want to deactivate this user?",
      areYouSureWantreactivateUser:
        "Are you sure you want to reactivate this user?",
      yes: "Yes",
      no: "No",
      deactivate: "Deactivate",
      reactivate: "Reactivate",
      ok: "Ok",
      reset: "Reset",
      invalidUserGroup: "Invalid user group",
      expiredInvitation: "Expired invitation",
      invitedAlreadyUsed: "Invite already used",
      thisEmailAlreadyInvited: "This email has already invited",
      thisEmailAlreadyUse: "This email is already in use",
      invitationNotFound: "Invitation not found",
      readOnly: "Read only",
      allowVisualizeData:
        "Allows you to view data and information without the ability to change it.",
    },
  },
  analytics: {
    waterLevel: "Water level",
    weather: "Weather",
    current: "Current",
    wind: "Wind",
    wave: "Wave",
    selectRegion: "Select a region",
    selectStation: "Select a station",
    sensorDataNotAvailable:
      "Sorry, but the sensor data for this station is not available.",
    errorGetSensorData:
      "Error to try get data for measured chart. Please contact us.",
    sensorData: "Sensor data",
    errorToTryGetDataStationOnAnalytics:
      "Error to try get data station on measured analytics chart type. Please contact us.",
    sorryButNoSensorsAreAvailableforData:
      "Sorry, but no sensors are available for this data type.",
  },
  atmOcean: {
    clickToGoBackPastForecasts: "Click to go back to past forecasts",
    youNeedSelectStationToExport:
      "Oops! You need to select a station to export the data.",
    waterFlow: "Water Flow",
    waveSea: "Wave Sea",
    waveSwell: "Wave Swell",
    selectStation: "Select a station",
    exportCsv: "Export .csv",
    time: "Time",
  },
  dynamicUKC: {
    dynamicClearanceNotAvailable:
      "Dynamic Under-Keel Clearance calculations are not available for you company. Would you like to request this functionality?",
    gotIt: "Got it!",
    skip: "skip",
    settings: "Settings",
    ukcRestriction: "UKC RESTRICTION",
    meters: "Meters",
    close: "Close",
    save: "Save",
    station: "Station",
    travelCode: "Travel code",
    dynamicUkcDocking: "Dynamic UKC - Docking",
    maneuverDraft: "Maneuver Draft",
    dynamicUkc: "Dynamic UKC",
    ukcRestrictionLower: "UKC restriction",
    dynamicUkcUndocking: " Dynamic UKC - Undocking",
    selectShip: "Select a ship",
    alert: "Alert",
    clickToBeRedirected: "Click below to be redirected to the Dynamic FAQ",
    gotToDynamicUkc: "Go to Dynamic UKC",
  },
  forecastChart: {
    forecastChartFormStation: {
      informStationDescription: "Inform a station description.",
      failedGetVirtualStationGeolocation:
        "Failed to get virtual station geolocation. Please contact us.",
      youAreOutOfRegionArea: "Oops! You are out of region area.",
      stationDescription: "Station description",
      save: "Save",
      doYouWantSaveStation: "Do you want to save station?",
      saveStation: "Save Station",
      areYouSureWantDeleteStation:
        "Are you sure you want to delete this station?",
      yes: "Yes",
      no: "No",
      requiredField: "Required field",
      invalidLatLng: "Invalid latitude and longitude",
      searchCoordsLatLng: "Search coordinates (latitude and longitude)",
      cancel: "Cancel",
      search: "Search",
      searchCoord: "Search coordinates",
      removeStation: "Remove station",
      unauthorizedUser:
        "Oops! It looks like you don't have permission to delete this station. Please get in touch with the system administrator",
      youOnlyHaveReadPermission: "You only have read permission",
    },
    forecastChartPage: {
      youAreOutOfRegionArea: "Oops! You are out of your region area.",
      thereIsAlreadyStationName: "There is already a station with this name:",
      errorToSaveVirtualStation:
        "Error to save virtual station. Please contact us.",
      successSationHasSaved: "Success! The station has been saved",
      errorToRemoveStation: "Error to remove station. Please contact us.",
      station: "Station:",
      errorToGetDataStationMeteogramChartType:
        "Error to try get data station on meteogram chart type. Please contact us.",
      errorToGetDataValidStationMeteogramChartType:
        "Error to try get data valid station on meteogram chart type. Please contact us.",
      stationWithInsight: "Station with Event",
      clickBlueMarkersInTheMap:
        "Click on the blue markers in the map if you would like",
      toDisplayForecastChartWaveSpectra:
        " to display forecast charts with data type Wave Spectra ",
      letsGo: "Let's go",
      newEraForForecast: "A new era for forecasting",
      geospatialInsight: "Geospatial Event",
      exploreGeospatialInsights:
        "Explore geospatial events to understand weather conditions in your region. Make decisions with a complete view of weather conditions in strategic areas to optimize your operations and planning.",
      minimizeRisks: "Minimize risks",
      analysingPoints: "analyzing points around you",
      customAnalysis:
        "Analysis Personalization: Personalize your climate analyzes according to the selected Events",
      newEraGeospatial: "A new geospatial era",
      inI4castPush: "in i4cast drives strategic decision-making.",
      insightForAllStations: "Event for all stations",
      chooseInsight:
        "Choose an event and navigate between stations to view it.",
      insightType: "Types of Event",
      nowToCreateAnInsight:
        "Now, when you create an Event, you can categorize it as 'Permissive' or 'Restrictive'. This means that when you select an Event in the Forecast charts screen, it will be represented according to the chosen category as follows:",
      permissive: "Permissive",
      noEvent: "No event",
      warning: "Attention",
      withEvent: "With event",
      restrictive: "Restrictive",
      gotIt: "Understood",
      back: "Back",
      next: "Next",
      skip: "Skip",
      last: "Close",
      createAlert: "Create Alert",
      createEvent: "Create event",
      sensorForecastData: "This station has no sensor. Showing forecast data.",
      noSensorWasFound: "No sensor was found for this region",
    },
    forecastChartPanelHeader: {
      noData: "No event found!",
      enterAtLeastThreeLetters: "Enter at least 3 letters",
      enterYourInsight: "Enter your Event here",
      showInsightInForecastCharts: "Show Event in Forecast Charts",
      insightWithoutData: "Stations without data",
      theGrayIconIndicates:
        "The gray icon indicates a lack of data for the selected Event",
      thereIsNoInsightDataAvailable:
        "There is no event data available for this station",
      noEventsForThisStation: "There are no events foreseen for this station",
      markAsFavorite: "Mark as favorite for quick access!",
      insightFavoriteSuccessOnSave:
        "Success! Your Event has been marked as favorite",
      opsErrorMarkingInsightAsFavorite: "Oops! Error marking event as favorite",
      insightFavoriteSuccessOnDelete:
        "Success! Your Event has been unmarked as favorite",
      opsErrorOnRemoveInsightAsFavorite:
        "Oops! Error on remove event as favorite",
      removeFavorite: "Remove favorite",
      selectStation: "Oops! Please select a station to show the event!",
      selectInsightToEnable: "Select an event to enable this visualization.",
      loading: "Loading",
    },
    forecastChartInsightTimeline: {
      swapToSetRanges: "Swipe to set ranges on the outer circles.",
      useTheCursorToAdjustTime:
        "Use the cursor to adjust time ranges in the outer circle. Drag to set new periods.",
    },
    forecastChartInsightLegend: {
      realTimeForecast: "Real-time forecast",
      forecastTimeline: "Timeline range",
      innerCircle: "Inner circle",
      outerCircle: "Outer circle",
    },
    forecastChartPanelEnvironmentalButtons: {
      weather: "Weather",
      wave: "Waves",
      visibility: "Visibility",
      waveHeight: "Wave Height",
      waveHeightMax: "Wave Height Max",
      wavePeakPeriod: "Peak Period",
      waveMeanPeriod: "Mean Period",
      waterFlow: "Water Flow",
      stationWithInsight: "Station with Event",
      wind: "Wind",
      wind10m: "Wind 10m",
      wind50m: "Wind 50m",
      wind100m: "Wind 100m",
      gust10m: "Gust 10m",
      gust50m: "Gust 50m",
      gust100m: "Gust 100m",
      temperature: "Temperature",
      waveTotal: "Wave",
      waveSea: "Sea",
      waveSwell: "Swell",
      rain: "Rain",
      accumulatedRain: "Accumulated Rain",
    },
    forecastChartPanelMap: {
      searchLocationOrLatLon: "search location or lat, lon",
      exactLocation: "Exact location",
      insightDataUpdate: "Geospatial markers reset.",
      insightDataUpdateDescription:
        "Last event calculation 15 minutes ago for this region. Data updated in selected area.",
      searchAddress: "Search address",
      noInsightData: "no Event data",
      sensorDataIsDelayed: "Sensor data is delayed.",
      loading: "Loading",
      noRadarDataAvailable: "No radar data available.",
    },
    forecastChartPanelMeteogram: {
      all: "All",
      dataInterval: "Data Interval",
      refreshToseeNewData: "Refresh to see new data available",
      thereIsnotDataAvailable:
        "Oops! There isn't {{empty}} {{location}} {{empty2}} data available at this location.",
      thereIsnotProbabilisticDataAvailable:
        "Oops! There is no {{empty}} {{location}} {{empty2}} probabilistic data available at this location.",
      thereIsnotSensorDataAvailable:
        "Oops! There is no {{empty}} {{location}} {{empty2}} measured data available at this location.",
      somethingWrong: "Ops! Something went wrong!",
      lastUpdatedAt: "Last updated at",
      delayedSensor: "The sensor data is",
      nextUpdateEstimatedAt: "Next update estimated at",
      aboutForecast: "About the forecasts",
      aboutSensor: "About sensors",
      aboutProbabilistic: "About probability",
      hours: " hours",
      hour: " hour",
      min: "min",
      share: "Share forecast",
      newsOnForecast: "New in forecasts",
      nowItsPossibleShare:
        "Now it is possible to share forecasts with other people easily and quickly! By clicking on",
      onForecastScreen:
        "on the Forecast Charts screen, you can email your predictions.",
      close: "close",
      gotIt: "Got it",
      insights: "Events",
      select: "Select",
      selectInsightFromList: "Select an Event to be displayed on the chart",
      compareInsightsWithMeteogram: "Compare events next to the meteogram!",
      selectInsight: "Select Event",
      showInsight: "Show Event",
      noEventsForThisStation: "There are no events foreseen for this station",
      toViewTheInsightSelectALongerPeriod:
        "In the next {{hours}}h there will be no event. To view the Event select a longer period",
      nowYouCanVisualizeTheInsightOnMeteogram:
        "Now you can view your Event along with the Meteogram! A station with Event is represented on the map in green, just select it, choose the Event you want to view and that's it! Your Event will appear on the graph",
      noEvent: "no event",
      warning: "warning",
      withEvent: "with event",
      insightOff: "Event off",
      insightCloseToBeingActivated: "Event close to being activated",
      insightOn: "Event on",
      confidence50: "50% confidence",
      confidence80: "80% confidence",
      median: "Median",
      windSpeed10m: "Wind speed 10m",
      windSpeed50m: "Wind speed 50m",
      significantWaveHeight: "Significant wave height",
      closeChart: "Close chart",
      unavailable: "Unavailable",
      deterministic: "Forecast",
      probabilistic: "Probability",
      cloud_base_height: "Cloud Base Height",
      windsGusts: "Winds/Gusts",
      slp: "Sea level pressure (Slp)",
      preciptation: "Rain",
      precipitationAccumulated: "Accumulated Rain",
      waveHeights: "Wave heights",
      peakPeriod: "Peak period",
      wavePower: "Wave Power",
      clickOnMapToOpen: "Click on the map to open the chart again.",
      itAppearsThatYourRegion:
        "This region does not have probability data for the selected variable",
      contactOurTeamToEnsure:
        "Contact us so we can implement this feature to you!✨",
      thisRegionDoesNotHavePrecip:
        "This region does not have data on minimum and maximum precipitation or the probability of rain.",
      thisRegionDoesNotHaveVisibility:
        "This region does not have data on minimum, maximum visibility and probability of visibility",
      getInTouch: "Get in touch",
      forecastChart: "Forecast chart",
      probabilisticChart: "Probability chart",
      sensorChart: "Measured data chart",
      metOceanForecastReport: "MetOcean Forecast Report",
      reportTable: "Tabular Forecast",
      probability: "Probability",
      reflectivity: "Reflectivity (dBZ)",
      vweak: "V.WEAK",
      weak: "WEAK",
      moderate: "MODERATE",
      strong: "STRONG",
      vstrong: "V.STRONG",
      precipitationPotential: "Rain Potential (mm/h)",
      radarDataUnavailable: "Radar data unavailable. Please try again later.",
      waterLevel: "Water Level",
      news: "News! ✨",
    },
    forecastTable: {
      title: "Tabular Forecast",
      tableColumnStation: "Station",
      tableTresholdTooltipLessThan: "Threshold less than",
      tableTresholdTooltipGreaterThan: "Threshold greater than",
      thresholdTooltip: "Enter the limit for this variable here.",
      dates: "Date/Time",
      getDataError: "An unexpected error occurred, please try again!",
      selectStationLabel: "Station",
      selectStationError: "An unexpected error occurred, please try again!",
      loadingForecastTableData: "Loading tabular forecast...",
      forecastTablePleaseWaitAMoment:
        "Please wait a moment, this may take a few seconds!",
      manageColumnsModalCancel: "Cancel",
      manageColumnsModalSave: "Save",
      hideColumn: "Hide column",
      manageColumns: "Manage columns",
      thresholdTitle: "Threshold",
      manageColumnTitle: "Manage Columns",
      environmentalVariableEnum: {
        weather: "Weather",
        weather_temperature: "Temperature",
        wave: "Waves",
        wave_sea: "Wind wave",
        wave_swell: "Swell wave",
        water_flow: "Water flow",
        wind_vel: "Wind 10m",
        wind_dir: "Dir. 10m",
        slp: "Slp",
        gust: "Gust 10m",
        water_level: "Water level",
        current_vel: "Current vel.",
        current_dir: "Current dir.",
        wave_height: "Sign. height",
        wave_dir: "Dir.",
        peak_period: "Peak period",
        mean_period: "Mean period",
        wave_height_sea: "Height",
        wave_dir_sea: "Dir.",
        peak_period_sea: "Peak period",
        wave_height_swell: "Height",
        wave_dir_swell: "Dir.",
        peak_period_swell: "Peak period",
        precip: "Rain",
        wind_vel_80m: "Wind 50m",
        wind_dir_80m: "Dir. 50m",
        gust_80m: "Gust 50m",
        wind_vel_100m: "Wind 100m",
        wind_dir_100m: "Dir. 100m",
        gust_100m: "Gust 100m",
        wave_height_max: "Max height",
        visibility: "Visibility",
        temp_air: "Air temp.",
        temp_water: "Water temp.",
        dew_point: "Dew point",
        wave_power: "Power",
        mean_period_swell: "Mean period",
        mean_period_sea: "Mean period",
        rel_humidity: "Relative humidity at 2m",
        precip_min_20km: "Minimum and maximum precipitation",
        precip_probability: "Rain probability",
        precipitation: "Rain",
        precipitation_accumulated: "Rain accumulated",
        water_properties: "Water properties",
        cloud_base_height: "Cloud base height",
        precip_accum_1h: "Rain accum. 1h",
        precip_accum_3h: "Rain accum. 3h",
        precip_accum_6h: "Rain accum. 6h",
        precip_accum_12h: "Rain accum. 12h",
        precip_accum_24h: "Rain accum. 24h",
        precip_accum_48h: "Rain accum. 48h",
        precip_accum_72h: "Rain accum. 72h",
        precip_accum_96h: "Rain accum. 96h",
        precip_accum_120h: "Rain accum. 120h",
        landslide_probability_risk: "Cumulative Rainfall Index",
        icing_probability: "Icing probability",
      },
    },
    forecastChartPanelMeteogramEnvironmentalButtons: {
      wave: "Wave",
      waveSea: "Wave sea",
      waveSwell: "Wave Swell",
    },
    forecastChartPanelMeteogramWeatherButtons: {
      weather: "Wind",
      weatherTemperature: "Temperature",
    },
    forecastChartPastForecast: {
      noPastDataAvailable: "No past data available",
      pastForecast: "Past Forecasts",
      pastMeasurement: "Past measurements",
      time: "Time:",
    },
    forecastChartRequestSpectraStationButton: {
      yourRequestSuccessfullySent: "Your request was successfully sent!",
      requestSeaSwellAtThisLocation:
        "Request sea and swell waves at this location",
    },
    forecastChartMeteogramStore: {
      errorTryGetDataChartMeteogram:
        "Error to try get data for chart meteogram. Please contact us.",
      noUpcomingEvents: "NO UPCOMING EVENTS",
    },
    forecastChartProbabilisticStore: {
      errorTryGetData: "Error to try get data. Please contact us.",
    },
    metOceanReport: {
      metOceanForecastReport: "MetOcean Forecast Report",
      generate: "Generate",
      selectAtLeastOneVariable: "Select at least one variable and one station",
      selectAtLeastOneStation: "Select a station for the selected variable",
      selectTheVariablesAndStations:
        "Select the variables and stations you want to view",
      weather: "Weather",
      wave: "Wave",
      waterFlow: "Water flow",
      waterProperties: "Water properties",
      cancel: "Cancel",
      generatingForecast: "Generating forecast report...",
      pleaseWaitAMoment:
        "Please wait a moment, this may take a few seconds! ⏳",
      weWereUnableToOpen:
        "We were unable to open the PDF because the browser blocked pop-ups. Please enable pop-ups in your browser settings and try again.",
    },
  },
  portOfCallStore: {
    errorToGetOperationWindowData:
      "Error to get operation window data. Please contact us.",
    errorToGetDockingDynamicUkcData:
      "Error to get docking dynamic UKC data. Please contact us.",
  },
  unitMeasurementStore: {
    errorToAddUnitMeasurement:
      "Error to add unit measurement. Please contact us",
  },
  whatIsNew: {
    whatIsNew: "What's new!",
    markAllAsRead: "Mark all as read.",
  },
  share: {
    shareForecast: "Share forecast",
    period: "Period",
    all: "all",
    environmentalVariables: "Environmental variables",
    weather: "Weather",
    selectStation: "Select station",
    wave: "Wave",
    waterFlow: "Water Flow",
    recipients: "Recipients",
    sendMeThisEmail: "Send me this email",
    externalRecipients: "External recipients",
    inviteToI4cast: "Invite to i4cast",
    message: "Message (optional)",
    cancel: "Cancel",
    submt: "Submit",
    inThisFieldItsPossibleShareByEmail:
      "Share via email with people who are not yet part of i4cast.",
    separateEmailsWithComma:
      "Separate emails with a comma. Ex: john@i4sea.com, new@i4sea.com",
    selectAtLeastOneEnvironmentalVariable:
      "Select at least one environmental variable and one season.",
    emailsBelowAreNotValid: "The emails below are not valid.",
    selectAtLeastOneVariable: "Select at least one variable and a station",
    youMustSelectAtLeast:
      "You must select at least one internal or external recipient",
    selectAtLeastOneStation: "Select a station for the selected variable",
    successEmailHasSend: "Success! Your email has been sent",
    errorSendingEmail: "Error sending the e-mail",
    helloIWouldLikeToShare:
      "Hello, I would like to share with you the i4cast forecast data. Attached to this email.",
    thereIsnotDataInThisStation:
      "There is no data of type {{environmentalTypeTranslated}} on station: {{stationName}}. Please select another station",
    water_flow: "Water Flow",
    shareReportByEmail:
      "Share a forecast report via email without leaving i4cast!",
    forGuestUsersMustUseAnEmailDomain:
      "Invite new users to i4cast. Only users with your company's domain can be invited (Ex.: joao@i4sea.com). If you need to invite other users, please contact us.",
  },
  dualList: {
    selectAll: "Select all",
    notSelected: "Not Selected",
    deselectAll: "Deselect All",
    selected: "Selected",
    search: "Search",
  },
  occurrence: {
    reportOccurrence: "Report occurrence",
    reportOccurrenceDetail:
      "Report an occurrence that had impact on your operations. Based on this, our system will be able to identify and notify similar forecasts in the future.",
    cancel: "Cancel",
    save: "Save",
    selectStation: "Select nearest station to the location of the occurrence.",
    selectEnvironmentalVariables:
      "Select the environmental variables that may have impacted this occurrence.",
    ocurrencePeriod: "Occurrence period",
    singleDate: "Single date",
    period: "Start and end",
    description: "Occurence description",
    strongWinds: "Strong winds stops container operations",
    latitude: "Latitude",
    longitude: "Longitude",
    forecastHelp: "Was the i4cast forecast right?",
    wantToBeNotified:
      "I want to be notified when similar conditions are forecasted",
    yes: "Yes",
    no: "No",
    wind: "Wind",
    current: "Current",
    wave: "Wave",
    rain: "Rain",
    fog: "Fog",
    waterLevel: "Water Level",
    temperature: "Temperature",
    occurrences: "Occurrences",
    newOccurrence: "Report occurrence",
    search: "Search",
    descriptionRequired: "Description is required!",
    stationRequired: "Station is required!",
    latitudeRequired: "Latitude is required!",
    longitudeRequired: "Longitude is required!",
    selectAtleastOneVariable:
      "Select at least one environmental variable that may have impacted the occurrence.",

    successReport: "Occurrence successfully reported!",
    errorReport: "Error while report occurrence!",
    deleteOccurrence: "Delete Occurrence",
    delete: "Delete",
    areYouSureWantDelete: "Are you sure you want to delete this Occurrence?",
    errorEditOccurrence: "Error while editing occurrence!",
    successEditOccurrence: "Success! Your occurrence has been saved",
    errorYouNeedToSelectAnOccurrence: "Error! You need to select an occurrence",
    youDonyHaveAOccurrenceYet:
      "You don't have a occurrence yet. Click the button to report one occurrence",
    addOccurrence: "Report Occurrence",
    time: "Time:",
    selectDate: "Please select a date",
    dateRequired: "Date is required!",
    exactLocation:
      "Would you like to provide the exact location of the incident? (optional)",
    selectOption: "Select a option!",
    startDateMustBeLessThanEndDate:
      "The start date must be less than the end date",
    windInfo:
      "By selecting this option, i4cast will use wind speed, direction, and gust data to identify similar events.",
    waveInfo:
      "By selecting this option, i4cast will use significant wave height, direction, and peak period data to identify similar events.",
    rainInfo:
      "By selecting this option, i4cast will use precipitation data to identify similar events.",
    fogInfo:
      "By selecting this option, i4cast will use visibility data to identify similar events.",
    temperatureInfo:
      "By selecting this option, i4cast will use air temperature data to identify similar events.",
    waterLevelInfo:
      "By selecting this option, i4cast will use water level data to identify similar events.",
    currentInfo:
      "By selecting this option, i4cast will use current speed and direction data to identify similar events.",
    forecastCorrect:
      "In your opinion, did i4cast's forecast help you identify this occurrence?",
    occurrencesAreEventsThatImpactYourOperation:
      "Occurrences are events that can impact your operations. Report occurrences so that i4cast becomes smarter. We will identify similar forecasts in the future and you will be notified.",
    startHourIsRequired: "Start hour is required",
    endHourIsRequired: "End hour is required",
    importOccurrence: "Import occurrence",
    selectFileToImport: "Select a file to import (pdf, excel, word and txt):",
    import: "Import",
    successOnImport:
      "Success! We have received your file with the occurrences.",
    youNeedToChooseFile: "Select a file to import!",
    weAreProcessingTheWorkSheet:
      "We are processing the worksheet with the occurrences. We will notify you shortly as soon as they are completed.",
    theSelectedFileExceedsMaxium:
      "The selected file exceeds the maximum allowed size of 5MB.",
    importYourOccurrencesSpreadSheet:
      "Do you already have a document with a record of weather events? Import it here and we'll register it for you!",
    successfullyUploaded: "Successfully uploaded!",
    yourFileWithOccurrenceWasSent:
      "Your file with occurrences was sent successfully and as soon as they are registered in i4cast, you will be notified by email!",
    iGotIt: "I got it!",
    selectAFile: "Select file",
    selectedFile: "Selected file:",
    noFileSelected: "No file selected",
    newsInOccurrence: "News in occurrences",
    nowItsPossibleImportSpreadSheet:
      "It is now possible to import a spreadsheet or document with your occurrences, making registration easier and making i4cast smarter!",
    try: "Try",
  },
  feedback: {
    successSendFeedback: "Success! Your feedback has been sent",
    errorSendFeedback: "Error sending feedback",
    thisFieldIsRequired: "This field is required",
    send: "To send",
    yes: "Yes",
    no: "No",
    typeYourAnswerHere: "Type your answer here",
  },
  manageStation: {
    manageStation: "Station Manager",
    configureWhichStationViewHistoricalData:
      "Configure which stations you want to view historical data",
    name: "Name",
    region: "Region",
    latLon: "Location (lat, lon)",
    historicalData: "Historical data",
    search: "Search",
    station: "Station",
    page: "Page",
    of: "of",
    filterBy: "Filter by",
    forecastDataType: "Forecast Data Type",
    weather: "Weather",
    wave: "Wave",
    waveSpectra: "Wave Spectra",
    waveSea: "Wave Sea",
    waveSwell: "Wave Swell",
    waterFlow: "Water Flow",
    dataHistory: "Data history",
    environmentalType: "Environmental type",
    selectAtLeastOneEnvironmentalType: "Select at least one environmental type",
    save: "Save",
    successEditStation: "Success! Your station has been saved",
    errorEditStation: "Error editing station!",
    errorNoEnvironmentalDataAtStation:
      "There are environmental types not available for this station!",
    enterAtLeastThreeLetters: "Enter at least 3 letters",
    notFound: "Not found",
    clean: "Clean",
  },
  analyticsReporting: {
    period: "Analysis period",
    environmentalType: "Environmental Type",
    weather: "Weather",
    location: "Location",
    environmentalVariable: "Environmental variable",
    windSpeed: "Wind speed",
    direction: "Direction",
    minimum: "Minimum",
    maximum: "Maximum",
    knots: "knots",
    forecastAdvancePeriod: "Period of each forecast",
    before: "before",
    generateAnalysis: "Generate analysis",
    hoursEarned: "Hours earned",
    hoursGainIsHowMuchMoreAccuratei4castWas:
      "Hours gained is how much more accurate i4cast was relative to the global model in hours.",
    moreThanGlobal: "more assertive than the global model",
    eventsCaptured: "Captured events",
    fillINTheFieldsBelowViewData: "Fill in the fields below to view the data",
    eventsCapturedRepresentTheQuantityOfEvents:
      "Events captured represents the number of events that i4cast captured more than the global model",
    degrees: "degrees",
    region: "Region",
    selectRegion: "Select a region",
    selectLocation: "Select a location",
    selectEvent: "Select an event",
    isGreaterOrEqual: "Greater or equal",
    isLessOrEqual: "Less or equal",
    startDate: "Start date",
    endDate: "End date",
    requiredField: "Required field",
    isGreaterOrEqualThan: "Greater than or equal to",
    isLessOrEqualThan: "Less than or equal to",
    between: "in between",
    to: "to",
    globalModel: "Global Model",
    sensor: "Measured",
    numberOfEvents: "Number of events",
    events: "Events",
    comparisonOfi4castForecastPerformance:
      "Comparison of i4cast forecast performance with global forecast.",
    fillAtLeastOneField: "Fill in at least one of the fields",
    generatingAnalysis: "generating analysis...",
    moreAssertiveForecastHours: "More assertive forecast than the global model",
    weAreGeneratingAnalysis:
      "We are generating your analysis, this may take a few seconds.",
    weDoNotHaveDataAvailable:
      "We do not have data available for the selected filter. Enter new information to try again.",
    timeCalculation: "Time Calculation",
    timeCalculationIsAPercentageOfTime:
      "Time calculation represents the percentage of time the filtered condition was active in your region",
    ofTheTimeWithWinds: "of the time with winds",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    mostFrequently: "More frequent in",
    errorGeneratingAnalytics: "Error generating analysis",
    theMaximumValueMustBeGreater:
      "The maximum value must be greater or equal than the minimum value",
    ofTheTimeWithWindsGreaterOrEqual:
      "of the period with greater or equal wind",
    ofTheTimeWithWindsLessOrEqual: "of the period with less or equal wind",
    someMonthsMayNotBeDisplayed:
      "Some months may not be displayed on the chart due to insufficient data for performance analysis.",
    monthlyAverageWindSpeed: "Monthly average wind speed",
    windDirection: "Wind direction",
    average: "Average",
    standardDeviation: "Standard deviation",
    eventFrequency: "Event frequency",
    first: "First",
  },
  eventHistory: {
    selectStationAndDefinePeriod:
      "Select a station and initial date to view a comparative analysis of the forecast over a 5 day period.",
    eventHistory: "Event history",
    selectStation: "Select a station",
    startDate: "Initial date",
    endDate: "Final date",
    weather: "Weather",
    wave: "Wave",
    waterFlow: "Water flow",
    waterLevel: "Water level",
    current: "Current",
    sensor: "Sensor",
    global: "Global model",
    noGlobalModelDataFound:
      "No global model data was found for the selected filter",
    noSensorDataFound: "No sensor data was found for the selected filter",
    noi4castDataFound: "No i4cast data was found for the selected filter",
    selectStationToViewData: "Select a station to view data",
    environmentalVariable: "Environmental variable",
  },
  eventAnalysis: {
    eventAnalysis: "Event Analysis",
    occurrence: "Occurrence",
    period: "Period",
    location: "Location",
    weather: "Weather",
    wave: "Wave",
    waterFlow: "Water flow",
    wind: "Wind",
    gust: "Gust",
    rain: "Rain",
    minimumValue: "Minimum of",
    averageValue: "Average of",
    maxValue: "Maximum",
    accumulatedValue: "Accumulation",
    peakValue: "Peak at",
    averageWindGust: "Average Wind | Gust",
    maxWindGust: "Maximum Wind | Gust",
    averageWavePeriod: "Average Height | Period",
    maxWavePeriod: "Maximum Height | Period",
    minWaterFlowCurrent: "Minimum Current",
    maxWaterFlowCurrent: "Maximum Current",
    timeSeries: "Time series",
    theChartBelowShows:
      "The chart below represents a time series of raw data from the occurrence period.",
    significantWaveHeight: "Significant wave height",
    wavePeakPeriod: "Wave peak period",
    waterLevel: "Water level",
    current: "Current",
    selectOccurrence: "Select an occurrence",
    selectAnOccurrenceToBegin: "Select an occurrence to begin your analysis",
    knots: "knots",
    latitude: "latitude",
    longitude: "longitude",
    noi4castDataFound: "No i4cast data was found for the selected occurrence",
  },
  environmentalVariableStore: {
    windSpeed: "Wind - Speed ​​at 10m",
    windDirection: "Wind - Direction at 10m",
    windGusts: "Wind - Gust at 10m",
    waterLevel: "Water level",
    currentVelocity: "Current - Speed",
    currentDirection: "Current - Direction",
    waveHeight: "Wave - Significant Height",
    waveDirection: "Wave - Direction of the Peak",
    peakPeriod: "Wave - Peak Period",
    meanPeriod: "Wave - Middle Period",
    seaWaveHeight: "Wave Sea - Significant Height",
    seaWaveDirection: "Wave Sea - Peak Direction",
    seaPeakPeriod: "Wave Sea - Peak Period",
    swellWaveHeight: "Wave Swell - Significant Swell Height",
    swellWaveDirection: "Wave Swell - Peak Direction",
    swellPeakPeriod: "Wave Swell - Peak Swell Period",
    precipitation: "Rain",
    windSpeedAt80m: "Wind - Speed ​​at 50m",
    windDirectionAt80m: "Wind - Direction at 50m",
    windGustsAt80m: "Wind - Gust at 50m",
    windSpeedAt100m: "Wind - Speed ​​at 100m",
    windDirectionAt100m: "Wind - Direction at 100m",
    windGustsAt100m: "Wind - Gust at 100m",
    maximumWaveHeight: "Wave - Maximum Height",
    visibility: "Visibility",
    airTemperature: "Air temperature",
    dewPoint: "Dew point",
    precicip_min_20km: "Minimum and maximum precipitation",
    precicip_probability: "Rain probability",
  },
  environmentalVariableEnum: {
    weather: "Weather",
    weather_temperature: "Temperature",
    wave: "Waves",
    wave_sea: "Wind wave",
    wave_swell: "Swell wave",
    water_flow: "Water flow",
    wind_vel: "Wind 10m",
    wind_dir: "Direction 10m",
    slp: "Slp",
    gust: "Gust 10m",
    water_level: "Water level",
    current_vel: "Current velocity",
    current_dir: "Current direction",
    wave_height: "Wave - significant height",
    wave_dir: "Wave - direction",
    peak_period: "Wave - peak period",
    mean_period: "Wave - mean period",
    wave_height_sea: "Wind wave - height",
    wave_dir_sea: "Wind wave - direction",
    peak_period_sea: "Wind wave - peak period",
    wave_height_swell: "Swell wave - height",
    wave_dir_swell: "Swell wave - direction",
    peak_period_swell: "Swell wave - peak period",
    precip: "Rain",
    wind_vel_80m: "Wind 50m",
    wind_dir_80m: "Direction 50m",
    gust_80m: "Gust 50m",
    wind_vel_100m: "Wind 100m",
    wind_dir_100m: "Direction 100m",
    gust_100m: "Gust 100m",
    wave_height_max: "Wave - max height",
    visibility: "Visibility",
    probability: "Probability (%)",
    visibility_maximum_20km: "Visibility max",
    visibility_minimum_20km: "Minimum and maximum visibility",
    visibility_probability_1000m: "Prob. Visibility less than 1km (%)",
    visibility_probability_1500m: "Prob. Visibility less than 1.5km (%)",
    visibility_probability_2000m: "Prob. Visibility less than 2km (%)",
    temp_air: "Air temperature",
    temp_water: "Water temperature",
    dew_point: "Dew point",
    wave_power: "Power",
    mean_period_swell: "Swell wave - mean period",
    mean_period_sea: "Wind wave - mean period",
    rel_humidity: "Relative humidity at 2m",
    precip_min_20km: "Minimum and maximum precipitation",
    precip_probability: "Rain probability",
    precipitation: "Rain",
    precipitation_accumulated: "Rain accumulated",
    precip_accum_1h: "Rain accum. 1h",
    precip_accum_3h: "Rain accum. 3h",
    precip_accum_6h: "Rain accum. 6h",
    precip_accum_12h: "Rain accum. 12h",
    precip_accum_24h: "Rain accum. 24h",
    precip_accum_48h: "Rain accum. 48h",
    precip_accum_72h: "Rain accum. 72h",
    precip_accum_96h: "Rain accum. 96h",
    precip_accum_120h: "Rain accum. 120h",
    landslide_probability_risk: "Cumulative Rainfall Index",
    icing_probability: "Icing probability",
  },
  utils: {
    now: "Right now",
    minAgo: "{{minutes}}min ago",
    oneHourAgo: "1 hour ago",
    hoursAgo: "{{hours}}h ago",
    oneDayAgo: "1 day ago",
    daysAgo: "{{days}} days ago",
    longTimeAgo: "Long time",
  },
  riverForecastChart: {
    extremeHigh: "Extreme high",
    veryHigh: "Very high",
    high: "High",
    mostLikely: "Base scenario",
    low: "Low",
    veryLow: "Very low",
    extremeLow: "Extreme low",
    sensor: "Sensor",
  },
  "404": {
    oopsPageNotFound: "Oops, page not found",
    goToLogin: "Go to login",
  },
  "500": {
    oopsAnErrorOccurred: "Oops, an error occurred",
    tryAgain: "Try again",
  },
  operationServices: {
    serviceRemovedSuccess: "Service removed successfully!",
    removalFailedContactUs: "Removal failed. Contact us",
    serviceUpdatedSucess: "Service updated successfully!",
    serviceCreatedSucess: "Service created successfully!",
    name: "Name",
    description: "Description",
    recurrence: "Recurrence",
    deleteService: "Delete service",
    areYouSureWantDeleteThisService:
      "Are you sure you want to delete this service?",
    delete: "Delete",
    cancel: "Cancel",
    loading: "Loading",
    noData: "No data available",
    serviceEdit: "Service Edit",
    serviceCreate: "Service Creation",
    serviceName: "Service name",
    serviceCost: "Service cost",
    shipMaintance: "Ship maintenance",
    moneyValue: "10,000.00",
    routineMaintance: "Maintenance routine in the morning",
    repeatEvery: "Repeat every",
    weeks: "weeks",
    repeat: "Repeat",
    start: "Start",
    selectTime: "Select data",
    end: "End",
    newShift: "New shift",
    startIn: "Start in",
    advanceHiring: "Hiring lead time",
    hours: "hours",
    editService: "Edit service",
    createService: "Create service",
    services: "Services",
    selectDate: "Select date",
    nameIsRequired: "Name is required",
    startTimeMustBeBeforeEndTime: "Start time must be before End time!",
    startDateRequired: "Start date is required!",
    endDateRequired: "End date is required!",
    seleactAtLeastOneDay: "Select at least one day",
    startTimeRequired: "Start time is required!",
    endTimeRequired: "End time is required!",
    doestHappenAgain: "Doesn't happen again",
    mondayFriday: "Monday to Friday",
    weekly: "Weekly",
    custom: "Custom",
    multipleShiftsDetected:
      "Multiple shifts with the same dates and times have been detected.",
    sunday: "S",
    monday: "M",
    tuesday: "T",
    wednesday: "w",
    thursday: "T",
    friday: "F",
    saturday: "S",
    currency: "Currency",
    whatHappensWhenRegistering: "What happens when registering a service?",
    yourServiceAndShiftsWill:
      "Your service and shifts will appear on the Gantt chart, allowing you to better visualize your schedule and track forecasting events to optimize your operation.",
    visualizeYourOperations:
      "Visualize your operations accurately! Register a service and monitor sea and weather conditions.",
  },
  time: {
    minutesAgo: "{{minutes}}m ago",
    inMinutes: "in {{minutes}}m",
    hoursAgo: "{{hours}}h ago",
    inHours: "in {{hours}}h",
    hoursMinutesAgo: "{{hours}}h {{minutes}}m ago",
    inHoursMinutes: "in {{hours}}h {{minutes}}m",
  },
  radarLegend: {
    showRainRdar: "Show rain radar",
    new: "New",
    nowcast: "Nowcast",
    oneHourNowcast: "up to 1h nowcast",
    light: "Light",
    moderate: "Moderate",
    heavy: "Heavy",
    rain: "Rain",
    snow: "Snow",
    precipitation: "Rain",
    error: {
      title: "Radar Error",
      unavailable: "Radar data temporarily unavailable",
      noData: "No radar data available",
      connectionLost: "Connection lost",
    },
  },
  layer: {
    selectLayer: "Layers",
    weather: "Weather",
    noLayer: "No layer",
    wind: "Wind 10m",
    gust: "Gust 10m",
    waves: "Waves",
    airTemp: "Air temp.",
    visibility: "Visibility",
    rain: "Rain",
    cloudCover: "Cloud Cover",
    radars: "Radars",
    weatherRadar: "Weather radar",
    layers: "Layers",
    airPressure: "Pressure",
    tooltipRemoveLayer: "Remove layer",
    nowcast: "Nowcast",
    waveHeight: "Significant wave height",
    waveHeightMax: "Wave Height Max",
    wavePower: "Wave Power",
    comingSoon: "Coming soon!",
    noWaveDataRegion:
      "No wave data available for your region. Contact us to enable it.",
    noWeatherDataRegion:
      "No weather data available for your region. Contact us to enable it.",
    maplayerDisclaimer:
      "Forecast chart at point locations may differ from the maps due to improved and more frequent Machine Learning updates.",
    startUpLayer: "Startup layer",
    typeLayer: "Enter layer here...",
    initialLayer: "Layer displayed when starting the map",
    noLayerDataWasFound:
      "Error loading layer data. Contact support if the issue persists.",
  },
  cities: {
    utc: "UTC (Coordinated Universal Time)",
    gmt: "GMT (Greenwich Mean Time)",

    saoPaulo: "Sao Paulo",
    recife: "Recife",
    bahia: "Bahia",
    buenosAires: "Buenos Aires",
    santiago: "Santiago",
    bogota: "Bogota",
    lima: "Lima",
    mexicoCity: "Mexico City",

    newYork: "New York",
    chicago: "Chicago",
    denver: "Denver",
    losAngeles: "Los Angeles",
    toronto: "Toronto",
    vancouver: "Vancouver",

    london: "London",
    lisbon: "Lisbon",
    paris: "Paris",
    berlin: "Berlin",
    madrid: "Madrid",
    rome: "Rome",
    stockholm: "Stockholm",
    copenhagen: "Copenhagen",
    amsterdam: "Amsterdam",
    athens: "Athens",

    tokyo: "Tokyo",
    shanghai: "Shanghai",
    seoul: "Seoul",
    bangkok: "Bangkok",
    mumbai: "Mumbai",
    dubai: "Dubai",

    sydney: "Sydney",
    auckland: "Auckland",
  },
  news: {
    news: "💡News - Operational Events",
    title: "New simplified event journey",
    paragraph1:
      "We rethought the way to create events, now you start by defining what you want to monitor, without having to decide everything at once.",
    paragraph2Part1: "This way,",
    paragraph2Bold1:
      "you first define what to track and adjust the usage later,",
    paragraph2Part2: "with more clarity and less effort, as needed.",
    paragraph3Part1: "As part of this evolution,",
    paragraph3Bold: "Insight is now called Event",
    paragraph3Part2: ", reflecting this new simplified journey.",
    exploreEvents: "Explore Events",
    gotIt: "Got it",
  },
  userPhoneEmailVerify: {
    iAgreeReceive:
      "I agree to receive alerts via WhatsApp about risky conditions.",
    updateYourContact: "Update your contact details on i4cast",
    keepAlwaysUpdated: "Be one step ahead! Receive risk alerts on WhatsApp.",
    typeEmail: "Enter your email",
    invalidEmail: "Invalid email",
    email: "Email",
    cellPhone: "Cell phone",
    confirm: "Confirm",
    weSentATextToYourPhone: "We sent a code via SMS to the number:",
    invalidCode: "Invalid code",
    resentCode: "Resend code",
    back: "Previous",
    confirmCode: "Confirm code",
    maximumAttempts:
      "Maximum attempts exceeded. Please try again in 10 minutes.",
    successYouPhone: "Success! Your email and phone number have been saved.",
    emailAlreadyInUse: "This email is already in use.",
    phoneAlreadyInUse: "This phone number is already in use.",
  },
  locations: {
    createLocation: "Create Location",
    editLocation: "Edit Location",
    area: "Area",
    locations: "Locations",
    description: "Create and edit locations registered by you or your company.",
    name: "Name",
    coordinateType: "Coordinate Type",
    coordinatesType: "Coordinates Type",
    coordinates: "Coordinates",
    coordinatesCount: "coordinate(s)",
    actions: "Actions",
    point: "Point",
    multipoint: "Multiple Points",
    route: "Route",
    error: "Error",
    deleteConfirmation: "Are you sure you want to delete this location?",
    locationName: "Location Name",
    locationNamePlaceholder: "Enter the location name",
    mapConfiguration: "Map Configuration",
    save: "Save",
    cancel: "Cancel",
    requiredField: "This field is required",
    monitoredArea: "Monitored Area",
    monitoredLocation: "Monitored Location",
    customPoint: "Selected Point",
    create: "Create",
    createLocationButton: "Create location",
    update: "Update",
    saveChanges: "Save changes",
    edit: "Edit",
    clear: "Clear",
    delete: "Delete",
    deleteLocation: "Delete Location",
    drawArea: "Draw an area",
    importGeojson: "Import GeoJSON",
    dropTheFile: "Drop the file here...",
    dragAndDrop: "Drag and drop a GeoJSON file here, or click to browse.",
    errorLoadingLocations: "Error loading locations",
    errorLoadingLocation: "Error loading location",
    errorCreatingLocation: "Error creating location",
    errorCreatingLocationNameInUse: "Location name is already in use",
    errorUpdatingLocation: "Error updating location",
    errorDeletingLocation: "Error deleting location",
    errorDeletingLocationInUse:
      "This location cannot be deleted because it is being used by an alert",
    enablePagination: "Enable Pagination",
    disablePagination: "Disable Pagination",
    noLocationsYet: "You don't have any locations registered yet",
    noLocationsFound: "No locations found for the searched term",
    pleaseDrawAnArea:
      "* Please draw an area on the map or import an existing one.",
    invalidArea:
      "Make sure the polygon is placed near your registered stations.",
    coordinatesRequired: "Coordinates are required",
    searchPlaceholder: "Search location...",
    saveGeofence: "Save Geofence",
  },
  event: {
    createEvent: "Create event",
    editEvent: "Edit event",
    eventName: "Event name",
    eventNamePlaceholder: "E.g.: Strong wind risk",
    alertName: "Event name",
    exampleRisk: "E.g.: Strong wind risk",
    alertConditions: "Event conditions",
    alertTypeChangeWarningTitle: "Attention to the change in event type",
    alertTypeChangeWarningDescription:
      "By changing the event type, the conditions will be replaced with the default conditions of the new type. Do you want to continue?",
    alertTypeChangeChoiceDescription:
      "When changing the event type, the conditions also change. How would you like to continue?",
    alertTypeChangeDescription:
      "When changing the event type, the conditions also change. How would you like to continue?",
    keepCurrentConditions: "Keep my conditions",
    useTemplateConditions: "Use default conditions",
    useTypeDefault: "Use default conditions",
    keepMyChanges: "Keep my conditions",
    step3Preferences: "Step 3 - Preferences",
    showInChart: "I want to see this event on the chart",
    ganttSettings: "Display on a dashboard",
    wantAlerts: "I want to be alerted of the forecast",
    wantToSeeOnChart: "I want to see this event on the chart",
    wantToReceiveAlerts: "I want to receive alerts",
    selectDashboard: "Link event to a dashboard",
    selectedDashboard: "Selected dashboard",
    selectPlaceholder: "Select an existing one or create a new one",
    dashboardHelpText:
      "The event you are creating will be displayed on the dashboard in the Operational Events screen.",
    noDashboardWarning: 'You don\'t have a dashboard yet, click "Create"',
    selectAlertType: "Select the type of Event:",
    selectRiskCategory: "Select a risk category",
    selectRiskDescription:
      "Choose an option, and we'll suggest the event conditions.",
    pleaseSelectRisk: "* Please select a risk type",
    pleaseAddCondition: "* Please add at least one condition",
    aboutRisk: "About the risk",
    aboutRiskGenericDescription:
      "Indicates risk conditions based on meteorological variables.",
    riskDescription_noCategory: "Event without a specific risk category.",
    riskDescription_extremeHeat:
      "Very high temperatures that affect people, equipment, and operations.",
    riskDescription_extremeWind:
      "Strong and persistent winds that may cause damage and disruptions.",
    riskDescription_extremeRain:
      "Heavy rainfall over a short period, with risk of water accumulation.",
    riskDescription_landslide:
      "Soil saturation caused by persistent rainfall, increasing landslide risk.",
    riskDescription_wildfire:
      "Conditions favorable to the spread of fire in natural areas.",
    riskDescription_treeFall:
      "Tree falls caused by strong winds and saturated soil.",
    riskDescription_roofDamage:
      "Structural damage to roofs caused by intense winds.",
    riskDescription_roughSea:
      "High waves and rough sea conditions that hinder maritime activities.",
    riskDescription_fog: "Fog formation that reduces visibility.",
    riskDescription_lowVisibility:
      "Reduced visibility that compromises movement and operations.",
    riskDescription_lightningStorm:
      "Storms with the possibility of lightning strikes.",
    // Risk type labels (internationalized)
    riskType: "Risk type",
    riskLabel_roughSea: "Rough sea",
    riskLabel_flooding: "Flooding",
    riskLabel_extremeWind: "Extreme\nwind",
    riskLabel_treeFall: "Tree fall",
    riskLabel_roofDamage: "Roof\ndamage",
    riskLabel_landslide: "Landslide",
    riskLabel_extremeHeat: "Extreme heat",
    riskLabel_wildfire: "Forest\nfire",
    riskLabel_fog: "Fog",
    riskLabel_lowVisibility: "Low\nvisibility",
    riskLabel_lightningStorm: "Lightning\nstorm",
    riskLabel_noCategory: "No\ncategory",
    riskCategoryUnavailable:
      "Not available in your region, contact us for information.",
    notAvailable: "Not available",
    eventConditions: "Event conditions",
    noConditionsAvailable: "No conditions available for this risk type.",
    seeMoreRiskTypes: "See more risk types",
    collapseRiskOptions: "Collapse options",
    i4castSuggestion: "Suggested by i4cast",
    backToI4castSuggestion: "Back to i4cast suggestion",
    create: "Create",
    save: "Save",
    eventAction: "Event action",
    eventActionTooltip:
      "Defines how weather conditions affect your operation. In Restrictive mode, the conditions limit or prevent the operation. In Permissive mode, the conditions are required for the operation to take place.",
    restrictive: "Restrictive",
    restrictiveTooltip:
      "Used for weather conditions that may restrict your operation.",
    permissive: "Permissive",
    permissiveTooltip:
      "Used for weather conditions that allow your operation to take place.",
    color: "Color",
    colorOnDashboard: "Color on dashboard",
    eventDescriptionLabel: "Description",
    eventDescriptionPlaceholder: "Describe the event...",
    red: "Red",
    orange: "Orange",
    yellow: "Yellow",
    blue: "Blue",
    new: "New",
    successEventCreated: "Event created successfully",
    eventUpdatedSuccess: "Event updated successfully",
    eventUpdatedError: "Error updating event",
    errorCreatingEvent: "Error creating event",
    errorCreatingInsight: "Error creating event visualization",
    errorCreatingAlert: "Error creating alert",
    selectAtLeastOneOption: "Select at least one option",
    dashboardRequired: "Select a dashboard",
    validationError: "Validation error",
    cancel: "Cancel",
    back: "Back",
    continue: "Continue",
    createDashboard: "Create dashboard",
    dashboardName: "Dashboard name",
    dashboardNamePlaceholder: "Enter dashboard name",
    dashboardCreatedSuccess: "Dashboard created successfully",
    errorCreatingDashboard: "Error creating dashboard",
    step1Location: "Step 1 - Location",
    step2Conditions: "Step 2 - Conditions",
    conditions: "Conditions",
    associatedAlerts: "Associated alerts",
    nameRequired: "Name is required",
    channelRequired: "Select at least one channel",
    userRequired: "Select at least one user",
    thisFieldRequired: "This field is required",
    monitoredArea: "Monitored area",
    conditionsEmptyStateTitle:
      "Add a weather condition that may affect your operation",
    conditionsEmptyStateCreateButton: "Create condition",
    conditionsEmptyStateSubtext:
      "or select a risk above and use our suggestions.",
  },
  validation: {
    nameRequired: "Event name is required",
    atLeastOneOption: "At least one option must be selected (Event or Alert)",
    locationRequired: "A monitored location must be selected",
    insightDataRequired: "Event data is required",
    dashboardRequired: "Dashboard selection is required",
    recipientsRequired: "At least one recipient is required",
    channelsRequired: "At least one channel must be selected",
  },
};
